import axios from "axios"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { MonthArrayAddAR } from "../../Reducer/MonthSliceAR"
import { AddArrayAdvanceReport, changeInfAdvanceReport } from "../../Reducer/AdvanceReprotsSlice"
import { FaPlay } from "react-icons/fa";
import { addCityArrayReport, changeCityArrayReportOpenInf, changeDirector, changeVisibleReportAllCity, changeVisibleReportOneBranch, changeVisibleReportOneCity, getUniqueCity } from "../../Reducer/CitySlice"
import { AddArticle } from "../../Reducer/ArticleSlice"
import { FaFilter, FaCheck, FaPencil, FaFileExcel  } from "react-icons/fa6";
import { IoClose } from "react-icons/io5"
import { setOpenAddArticleED } from "../../Reducer/ModalSlice"
import { openAddedAdminArticle, openEditAddedArticle } from "../../Reducer/AddArticleInARSlice"
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { addUsers } from "../../Reducer/UserSlice"
import { roleId } from "../Constants/app"

function SummaryReports(){
    const CityArrayReport = useSelector(state => state.CitySlice.CityArrayReport);
    const UniqueCityArray = useSelector(state => state.CitySlice.UniqueCityArray);
    const User = useSelector(state => state.UserSlice.User);
    const Server = useSelector(state => state.UserSlice.Server);
    const ArrayUsers = useSelector(state => state.UserSlice.ArrayUsers);
    const AdvanceReportED = useSelector(state => state.AdvanceReprotsSlice.AdvanceReportED);
    const Article = useSelector(state => state.ArticleSlice.Article);
    const AddAdminArticle = useSelector(state => state.AddArticleInARSlice.AddAdminArticle);
    const AddAdminOtherExpenditure = useSelector(state => state.AddArticleInARSlice.AddAdminOtherExpenditure);
    const MonthArrayAR = useSelector(state => state.MonthSliceAR.MonthArrayAR);

    const [isLoading, setLoading] = useState(true);
    const [DatePeriodForInput, setDatePeriodForInput] = useState({Min: 0, Max: 1});
    const [SelectedPeriod, SelectPeriod] = useState({Min: '', Max: ''});
    const [OpenModalArticles, setOpenModalArticles] = useState(false);
    const [SelectedArticle, SelectArticle] = useState({id: 0, idCity: 0, TransactionType: 'All'});
    const [OpenModalArticlesOtherExpenditure, setOpenModalArticlesOtherExpenditure] = useState(false);
    const [SelectedArticleOtherExpenditure, SelectArticleOtherExpenditure] = useState({idCity: 0, TransactionType: 'All'});
    const [openFilter, setOpenFilter] = useState(false);
    const [VisibleTransactionTypeCash, setVisibleTransactionTypeCash] = useState(true);
    const [VisibleTransactionTypeNonCash, setVisibleTransactionTypeNonCash] = useState(true);
    const [VisibleResult, setVisibleResult] = useState(true);
    const [VisibleResultBlock, setVisibleResultBlock] = useState(true);
    const [openSearchingCity, setOpenSearchingCity] = useState(false);
    const [openSearchingMonth, setOpenSearchingMonth] = useState(false);
    const [searchingMonth, setSearchingMonth] = useState(MonthArrayAR || []);
    const [SearchingCity, setSearchingCity] = useState('');
    const [SearchingBranch, setSearchingBranch] = useState('');
    const [SelectedAllCity, setSelectedAllCity] = useState(true);
    const [OpenIncomeArticlesCashResultBlock, setOpenIncomeArticlesCashResultBlock] = useState(false);
    const [OpenExpenditureArticlesCashResultBlock, setOpenExpenditureArticlesCashResultBlock] = useState(false);
    const [OpenIncomeArticlesNonCashResultBlock, setOpenIncomeArticlesNonCashResultBlock] = useState(false);
    const [OpenExpenditureArticlesNonCashResultBlock, setOpenExpenditureArticlesNonCashResultBlock] = useState(false);
    const [OpenIncomeArticlesResultResultBlock, setOpenIncomeArticlesResultResultBlock] = useState(false);
    const [OpenExpenditureArticlesResultResultBlock, setOpenExpenditureArticlesResultResultBlock] = useState(false);
    const [OpenBackgroundInformationResultBlock, setOpenBackgroundInformationResultBlock] = useState(false);
    const [isLoadingAdminSumCash, setLoadingAdminSumCash] = useState(true);
    const [isLoadingAdminSumNonCash, setLoadingAdminSumNonCash] = useState(true);
    const [isLoadingAdminComment, setLoadingAdminComment] = useState(true);
    const [isLoadingRevenueFrontpad, setLoadingRevenueFrontpad] = useState(true);
    const [isLoadingNumDelivery, setLoadingNumDelivery] = useState(true);
    const [isLoadingPercentRemains, setLoadingPercentRemains] = useState(true);
    const [isLoadingDirectorChange, setLoadingDirectorChange] = useState(true);
    const [openSearchingDirector, setOpenSearchingDirector] = useState(false);
    const [SearchingDirector, setSearchingDirector] = useState('');
    const [SelectedDirector, SelectDirector] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState('');
    const [openDateInput, setOpenDateInput] = useState(false);

    const dispatch = useDispatch();

    const checkSelectedAllCity = () => {
        let indeterminateCheck = UniqueCityArray.filter((el) => el.VisibleReportCity === true).length;
        if(indeterminateCheck === 0) return(setSelectedAllCity(false));
        if(indeterminateCheck > 0 && indeterminateCheck < UniqueCityArray.length) return(setSelectedAllCity('indeterminate'));
        return(setSelectedAllCity(true));
    }

    const getArticle = () => {
        setLoading(false)
        axios.get(Server + 'articlesofmoneymovements?_limit=-1', { headers: { Authorization: 'Bearer ' + User.jwt }})
        .then((response) => {
            dispatch(AddArticle(response.data));
            setLoading(true);
        })
    }

    const getMonth = async () => {
        setLoading(false)
        await axios.get(Server + 'monthforadvancereports?_limit=-1&_sort=id:DESC', { headers: { Authorization: 'Bearer ' + User.jwt }})
        .then((response) => {
            dispatch(MonthArrayAddAR(response.data));
            const lastMonth = response.data[0];
            const firstMonth = response.data[response.data.length - 1];
            
            let MinDateForInput = firstMonth.YearValue + '-' + String(firstMonth.MonthValue).padStart(2, '0') + '-01';
            let MinDateForSelectPeriod = lastMonth.YearValue + '-' + String(lastMonth.MonthValue).padStart(2, '0') + '-01';
            let MaxDateForInput = 0;
            MaxDateForInput = `${lastMonth.YearValue}-${String(lastMonth.MonthValue).padStart(2, '0')}-${checkMaxDatePeriod(lastMonth.MonthValue, lastMonth.YearValue)}`;
            setDatePeriodForInput({Min: MinDateForInput, Max: MaxDateForInput});
            SelectPeriod({Min: MinDateForSelectPeriod, Max: MaxDateForInput});
            setSelectedMonth(lastMonth);
            setLoading(true);
        })
    }

    const checkMaxDatePeriod = (month, year) => {
        if(month === 1 || month === 3 || month === 5 || month === 7 || month === 8 || month === 10 || month === 12) return 31;
        if(month === 2) {
            if(year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) return 29;
            return 28;
        }
        return 30;        
    }

    const renderSelectMonth = () => {
        if(selectedMonth) return selectedMonth.Name;
        if(SelectedPeriod.Min && SelectedPeriod.Min) return 'Период';
        return '';
    }


    const getCityAdvancereport = async () => {
        setLoading(false)
        await axios.get(Server + 'cityadvancereports?_limit=-1', { headers: { Authorization: 'Bearer ' + User.jwt }})
        .then(async (response) => {
            await dispatch(AddArrayAdvanceReport(response.data));
            setLoading(true);
        })
    }

    const getCityAdvancereportNoLoad = async () => {
        setLoading(false);
        await axios.get(Server + 'cityadvancereports?_limit=-1', { headers: { Authorization: 'Bearer ' + User.jwt}})
        .then(async (response) => {
            await dispatch(AddArrayAdvanceReport(response.data));
            setLoading(true);
        })
    }

    const getDirector = () => {
        axios.get(Server + "users?_limit=-1", { headers: { Authorization: 'Bearer ' + User.jwt}})
        .then((response) => {
            let addedUsersArray = response.data.filter(el => el.role.id === roleId.director);
            dispatch(addUsers(addedUsersArray));
            setSearchingDirector(addedUsersArray);
        })
    }

    const getData = () => {
        dispatch(addCityArrayReport());
        dispatch(getUniqueCity());
        getMonth();
        getCityAdvancereport();
        getArticle();
        getDirector();
    }

    const handleClickExport = () => {
        var TransactionType = [];
        var SheetData = [];
        //получение строки нал/безнла/итого и строки "Сумма"
        if(VisibleResultBlock) {
            if(VisibleTransactionTypeCash) {
                TransactionType.push('Нал.');
                TransactionType.push('Сумма');
            }
            if(VisibleTransactionTypeNonCash) {
                TransactionType.push('Безнал.');
                TransactionType.push('Сумма');
            }
            if(VisibleResult) {
                TransactionType.push('Итого');
                TransactionType.push('Сумма');
            }
        }

        CityArrayReport.map((el) =>  {
            if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                if(VisibleTransactionTypeCash) {
                    TransactionType.push('Нал.');
                    TransactionType.push('Сумма');
                }

                if(VisibleTransactionTypeNonCash) {
                    TransactionType.push('Безнал.');
                    TransactionType.push('Сумма');
                }
                
                if(VisibleResult) {
                    TransactionType.push('Итого');
                    TransactionType.push('Сумма');
                }
            }
            return(el)
        });

        SheetData.push(TransactionType);
        TransactionType = [];

        var CityPuhsed = [];
        var AdressPuhsed = [];
        var PushedData = [];

        //получение строк с названием города, адресом филиала и получение строки "доход", пустые строки для корректности отображения
        if(VisibleResultBlock) {
                if(VisibleTransactionTypeCash) {
                    CityPuhsed.push('Свод');
                    AdressPuhsed.push('Итог');
                    PushedData.push('Доход');
                    CityPuhsed.push('');
                    AdressPuhsed.push('');
                    PushedData.push({t: "n", v: getSumArticle(null, 'income', 'Cash')});
                }

                if(VisibleTransactionTypeNonCash) {
                    CityPuhsed.push('Свод');
                    AdressPuhsed.push('Итог');
                    PushedData.push('Доход');
                    CityPuhsed.push('');
                    AdressPuhsed.push('');
                    PushedData.push({t: "n", v: getSumArticle(null, 'income', 'NonCash')});
                }

                if(VisibleResult) {
                    CityPuhsed.push('Свод');
                    AdressPuhsed.push('Итог');
                    PushedData.push('Доход');
                    CityPuhsed.push('');
                    AdressPuhsed.push('');
                    PushedData.push({t: "n", v: getSumArticle(null, 'income')});
                }
            }
    
            CityArrayReport.map((el) =>  {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        CityPuhsed.push(el.City);
                        AdressPuhsed.push(el.Adress);
                        PushedData.push('Доход');
                        CityPuhsed.push('');
                        AdressPuhsed.push('');
                        PushedData.push({t: "n", v: getSumArticle(null, 'income', 'Cash', el.id)});
                    }

                    if(VisibleTransactionTypeNonCash) {
                        CityPuhsed.push(el.City);
                        AdressPuhsed.push(el.Adress);
                        PushedData.push('Доход');
                        CityPuhsed.push('');
                        AdressPuhsed.push('');
                        PushedData.push({t: "n", v: getSumArticle(null, 'income', 'NonCash', el.id)});
                    }

                    if(VisibleResult) {
                        CityPuhsed.push(el.City);
                        AdressPuhsed.push(el.Adress);
                        PushedData.push('Доход');
                        CityPuhsed.push('');
                        AdressPuhsed.push('');
                        PushedData.push({t: "n", v: getSumArticle(null, 'income', null, el.id)});
                    }
                }
                return(el);
            })

            SheetData.push(CityPuhsed);
            SheetData.push(AdressPuhsed);
            SheetData.push('');
            SheetData.push(PushedData);

            CityPuhsed = [];
            AdressPuhsed = [];
            PushedData = [];

            //получение статей типа "доход" и их суммы
            Article.Income.map((article) => {
                if(VisibleResultBlock) {
                    if(VisibleTransactionTypeCash) {
                        if(article.TransactionType === 'Cash' || article.TransactionType === 'All') {
                            PushedData.push(article.Name);
                            PushedData.push({t: "n", v: getSumArticle(article.id, 'income', 'Cash')});
                        } else {
                            PushedData.push('');
                            PushedData.push('');
                        }
                    }

                    if(VisibleTransactionTypeNonCash) {
                        if(article.TransactionType === 'NonCash' || article.TransactionType === 'All') {
                            PushedData.push(article.Name);
                            PushedData.push({t: "n", v: getSumArticle(article.id, 'income', 'NonCash')});
                        } else {
                            PushedData.push('');
                            PushedData.push('');
                        }
                    }

                    if(VisibleResult) {
                        PushedData.push(article.Name);
                        PushedData.push({t: "n", v: getSumArticle(article.id, 'income')});
                    }
                }

                CityArrayReport.map((el) => {
                    if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector))
                    {
                        if(VisibleTransactionTypeCash) {
                            if(article.TransactionType === 'Cash' || article.TransactionType === 'All') {
                                PushedData.push(article.Name);
                                PushedData.push({t: "n", v: getSumArticle(article.id, 'income', 'Cash', el.id)});
                            } else {
                                PushedData.push('');
                                PushedData.push('');
                            }
                        }
    
                        if(VisibleTransactionTypeNonCash) {
                            if(article.TransactionType === 'NonCash' || article.TransactionType === 'All') {
                                PushedData.push(article.Name);
                                PushedData.push({t: "n", v: getSumArticle(article.id, 'income', 'NonCash', el.id)});
                            } else {
                                PushedData.push('');
                                PushedData.push('');
                            }
                        }

                        if(VisibleResult) {
                            PushedData.push(article.Name);
                            PushedData.push({t: "n", v: getSumArticle(article.id, 'income', null, el.id)});
                        }
                    }
                    return(el);
                });

            SheetData.push(PushedData);
            PushedData = [];
            return(article);
        });
            
        SheetData.push('');
        //получение строки "Расход" и суммы расхода
        if(VisibleResultBlock) {
            if(VisibleTransactionTypeCash) {
                PushedData.push('Расход');
                PushedData.push({t: "n", v: getSumArticle(null, 'expenditure', 'Cash')});
            }

            if(VisibleTransactionTypeNonCash) {
                PushedData.push('Расход');
                PushedData.push({t: "n", v: getSumArticle(null, 'expenditure', 'NonCash')});
            }

            if(VisibleResult) {
                PushedData.push('Расход');
                PushedData.push({t: "n",v: getSumArticle(null, 'expenditure')});
            }
        }
    
        CityArrayReport.map((el) => {
            if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                if(VisibleTransactionTypeCash) {
                    PushedData.push('Расход');
                    PushedData.push({t: "n", v: getSumArticle(null, 'expenditure', 'Cash', el.id)});
                }

                if(VisibleTransactionTypeNonCash) {
                    PushedData.push('Расход');
                    PushedData.push({t: "n", v: getSumArticle(null, 'expenditure', 'NonCash', el.id)});
                }

                if(VisibleResult) {
                    PushedData.push('Расход')
                    PushedData.push({t: "n",v: getSumArticle(null, 'expenditure', null, el.id)})
                }
            }
            return(el);
        });

        SheetData.push(PushedData);
        PushedData = [];

        //получение статей типа "Расход" и их суммы
        Article.Expenditure.map((article) => {
            if(VisibleResultBlock) {
                if(VisibleTransactionTypeCash) {
                    if(article.TransactionType === 'Cash' || article.TransactionType === 'All') {
                        PushedData.push(article.Name)
                        PushedData.push({t: "n", v: getSumArticle(article.id, 'expenditure', 'Cash')});
                    } else {
                        PushedData.push('');
                        PushedData.push('');
                    }
                }

                if(VisibleTransactionTypeNonCash) {
                    if(article.TransactionType === 'NonCash' || article.TransactionType === 'All') {
                        PushedData.push(article.Name)
                        PushedData.push({t: "n", v: getSumArticle(article.id, 'expenditure', 'NonCash')})
                    } else {
                        PushedData.push('');
                        PushedData.push('');
                    }
                }

                if(VisibleResult) {
                    const sum = getSumArticle(article.id, 'expenditure', null)
                    const percent = getPercent(sum, getSumArticle(null, 'income'));
                    const value = `${sum} (${percent})`
                    PushedData.push(article.Name);
                    PushedData.push({t: "s", v: value});
                }
            };

            CityArrayReport.map((el) => {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        if(article.TransactionType === 'Cash' || article.TransactionType === 'All') {
                            PushedData.push(article.Name);
                            PushedData.push({t: "n", v: getSumArticle(article.id, 'expenditure', 'Cash', el.id)});
                        } else {
                            PushedData.push('');
                            PushedData.push('');
                        }
                    }

                    if(VisibleTransactionTypeNonCash) {
                        if(article.TransactionType === 'NonCash' || article.TransactionType === 'All') {
                            PushedData.push(article.Name);
                            PushedData.push({t: "n", v: getSumArticle(article.id, 'expenditure', 'NonCash', el.id)});
                        } else {
                            PushedData.push('');
                            PushedData.push('');
                        }
                    }

                    if(VisibleResult) {
                        const sum = getSumArticle(article.id, 'expenditure', null, el.id)
                        const percent = getPercent(sum, getSumArticle(null, 'income', null, el.id));
                        const value = `${sum} (${percent})`
                        PushedData.push(article.Name);
                        PushedData.push({t: "s", v: value});
                    }
                }
                return(el);
            });

            SheetData.push(PushedData);
            PushedData = [];
            
            return(article);
        });

        SheetData.push('');

        if(VisibleResultBlock) {
            if(VisibleTransactionTypeCash) {
                PushedData.push('Расход')
                PushedData.push({t: "n", v:  getSumArticle(null, 'expenditure', 'Cash')});
            }

            if(VisibleTransactionTypeNonCash) {
                PushedData.push('Расход')
                PushedData.push({t: "n", v:  getSumArticle(null, 'expenditure', 'NonCash')});
            }

            if(VisibleResult) {
                PushedData.push('Расход')
                PushedData.push({t: "n", v:  getSumArticle(null, 'expenditure')});
            }
        }
    
        CityArrayReport.map((el) =>  {
            if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                if(VisibleTransactionTypeCash) {
                    PushedData.push('Расход');
                    PushedData.push({t: "n", v:  getSumArticle(null, 'expenditure', 'Cash', el.id)});
                }

                if(VisibleTransactionTypeNonCash) {
                    PushedData.push('Расход');
                    PushedData.push({t: "n", v:  getSumArticle(null, 'expenditure', 'NonCash', el.id)});
                }

                if(VisibleResult) {
                    PushedData.push('Расход');
                    PushedData.push({t: "n", v:  getSumArticle(null, 'expenditure', null, el.id)});
                }
            }
            return(el);
        })

        SheetData.push(PushedData);
        SheetData.push('');
        PushedData = [];

        //получение строки "инкассация" и суммы инкассации
        if(VisibleResultBlock) {
            if(VisibleTransactionTypeCash) {
                PushedData.push('Внесение "+"/Инкассация "-"');
                PushedData.push({t: "n", v:  getSumArticle(null, 'collection', 'Cash')});
            }

            if(VisibleTransactionTypeNonCash) {
                PushedData.push('Внесение "+"/Инкассация "-"');
                PushedData.push({t: "n", v:  getSumArticle(null, 'collection', 'NonCash')});
            }

            if(VisibleResult) {
                PushedData.push('Внесение "+"/Инкассация "-"');
                PushedData.push({t: "n", v:  getSumArticle(null, 'collection')});
            }
        }
    
        CityArrayReport.map((el) => {
            if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                if(VisibleTransactionTypeCash) {
                    PushedData.push('Внесение "+"/Инкассация "-"')
                    PushedData.push({t: "n", v:  getSumArticle(null, 'collection', 'Cash', el.id)});
                }

                if(VisibleTransactionTypeNonCash) {
                    PushedData.push('Внесение "+"/Инкассация "-"');
                    PushedData.push({t: "n", v:  getSumArticle(null, 'collection', 'NonCash', el.id)});
                }

                if(VisibleResult) {
                    PushedData.push('Внесение "+"/Инкассация "-"');
                    PushedData.push({t: "n", v:  getSumArticle(null, 'collection', null, el.id)});
                }
            }
            return(el);
        })
    
        SheetData.push(PushedData);
        SheetData.push('');
        PushedData = [];

        //получение строки "остаток" и суммы остатка
        if(VisibleResultBlock) {
            if(VisibleTransactionTypeCash) {
                PushedData.push('Остаток');
                PushedData.push({t: "n", v: (getSumArticle(null, 'income', 'Cash') - getSumArticle(null, 'expenditure', 'Cash')).toFixed(2)});
            }

            if(VisibleTransactionTypeNonCash) {
                PushedData.push('Остаток')
                PushedData.push({t: "n", v: (getSumArticle(null, 'income', 'NonCash') - getSumArticle(null, 'expenditure', 'NonCash')).toFixed(2)});
            }

            if(VisibleResult) {
                PushedData.push('Остаток');
                PushedData.push({t: "n", v: (getSumArticle(null, 'income') - getSumArticle(null, 'expenditure')).toFixed(2)});
            }
        }
    
        CityArrayReport.map((el) => {
            if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                if(VisibleTransactionTypeCash) {
                    PushedData.push('Остаток');
                    PushedData.push({t: "n", v: (getSumArticle(null, 'income', 'Cash', el.id) - getSumArticle(null, 'expenditure', 'Cash', el.id)).toFixed(2)});
                }

                if(VisibleTransactionTypeNonCash) {
                    PushedData.push('Остаток');
                    PushedData.push({t: "n", v: (getSumArticle(null, 'income', 'NonCash', el.id) - getSumArticle(null, 'expenditure', 'NonCash', el.id)).toFixed(2)});
                }

                if(VisibleResult) {
                    PushedData.push('Остаток');
                    PushedData.push({t: "n", v: (getSumArticle(null, 'income', null, el.id) - getSumArticle(null, 'expenditure', null, el.id)).toFixed(2)});
                }
            }
            return(el);
        });

        SheetData.push(PushedData);
        PushedData = [];

        //Получение справочной информации
        if(VisibleResult) {
            //Получение строки "справочная информация"
            if(VisibleResultBlock) {
                if(VisibleTransactionTypeCash) {
                    PushedData.push('');
                    PushedData.push('');
                }
                if(VisibleTransactionTypeNonCash) {
                    PushedData.push('');
                    PushedData.push('');
                }                    
                
                PushedData.push('Cправочная информация');
                PushedData.push('');
            }              
        
            CityArrayReport.map((el) =>  {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Cправочная информация');
                    PushedData.push('');
                }
                return(el);
            })

            SheetData.push('');
            SheetData.push(PushedData);
            PushedData = [];

            //Получение информации о справочной информации

            //Получение "Выручка ФП"
            if(VisibleResultBlock) {
                if(VisibleTransactionTypeCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                if(VisibleTransactionTypeNonCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                PushedData.push('Выручка ФП');
                PushedData.push({t: "n", v: getRevenueFrontpad()});
            };

            CityArrayReport.map((el) => {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Выручка ФП');
                    PushedData.push({t: "n", v: getRevenueFrontpad(el.id)});
                }
                return(el)
            });

            SheetData.push(PushedData);
            PushedData = [];
            
            //Получение "Выручка"
            if(VisibleResultBlock) {
                if(VisibleTransactionTypeCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                if(VisibleTransactionTypeNonCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                PushedData.push('Выручка');
                PushedData.push({t: "n", v: getRevenue()});
            };

            CityArrayReport.map((el) => {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Выручка');
                    PushedData.push({t: "n", v: getRevenue(el.id)});
                }
                return(el)
            });

            SheetData.push(PushedData);
            PushedData = [];

            //Получение "Выручка %"
            if(VisibleResultBlock) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Выручка %');
                    PushedData.push({t: "n", v: getRevenuePercent()});
            }

            CityArrayReport.map((el) => {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Выручка %');
                    PushedData.push({t: "n", v: getRevenuePercent(el.id)});                  
                }
                return(el);
            });

            SheetData.push(PushedData);
            PushedData = [];

            //Получение "Закупка"
            if(VisibleResultBlock) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Закупка');
                    PushedData.push({t: "n", v: getByName('Закупка')});
            }

            CityArrayReport.map((el) => {
                if(el.VisibleReport ?? (!SelectedDirector || el.DirectorID === SelectedDirector))
                {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Закупка');
                    PushedData.push({t: "n", v: getByName('Закупка', el.id)});
                }
                return(el)
            });

            SheetData.push(PushedData);
            PushedData = [];

            //Получение "Закупка %"
            if(VisibleResultBlock) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Закупка %');
                    PushedData.push({t: "n", v: getPercentByName('Закупка')});
            }

            CityArrayReport.map((el) => {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Закупка %');
                    PushedData.push({t: "n", v: getPercentByName('Закупка', el.id)});
                }
                return(el);
            });

            SheetData.push(PushedData);
            PushedData = [];

            //Получение "Заработная плата"
            if(VisibleResultBlock)
                {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Заработная плата');
                    PushedData.push({t: "n", v: getByName('Заработная плата')});
            }

            CityArrayReport.map((el) => {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Заработная плата');
                    PushedData.push({t: "n", v: getByName('Заработная плата', el.id)});
                }
                return(el)
            });

            SheetData.push(PushedData);
            PushedData = [];

            //Получение "Заработная плата %"
            if(VisibleResultBlock) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Заработная плата %');
                    PushedData.push({t: "n", v: getPercentByName('Заработная плата')});
            }

            CityArrayReport.map((el) => {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Заработная плата %');
                    PushedData.push({t: "n", v: getPercentByName('Заработная плата', el.id)});
                }
                return(el);
            });

            SheetData.push(PushedData);
            PushedData = [];

            //Получение "Прочие расходы"
            if(VisibleResultBlock) {
                if(VisibleTransactionTypeCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                if(VisibleTransactionTypeNonCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                PushedData.push('Прочие расходы');
                PushedData.push({t: "n", v: getOtherExpenses()});
            }

            CityArrayReport.map((el) => {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Прочие расходы');
                    PushedData.push({t: "n", v: getOtherExpenses(el.id)});
                }
                return(el)
            });

            SheetData.push(PushedData);
            PushedData = [];

            //Получение "Прочие расходы %"
            if(VisibleResultBlock) {
                if(VisibleTransactionTypeCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                if(VisibleTransactionTypeNonCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                PushedData.push('Прочие расходы %')
                PushedData.push({t: "n", v: getOtherExpensesPercent()});
            }

            CityArrayReport.map((el) => {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Прочие расходы %');
                    PushedData.push({t: "n", v: getOtherExpensesPercent(el.id)});
                }
                return(el);
            });

            SheetData.push(PushedData);
            PushedData = [];

            //Получение "Оплата доставки"
            if(VisibleResultBlock) {
                if(VisibleTransactionTypeCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                if(VisibleTransactionTypeNonCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                PushedData.push('Оплата доставки');
                PushedData.push({t: "n", v: getByName('Оплата доставки')});
            }

            CityArrayReport.map((el) => {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Оплата доставки');
                    PushedData.push({t: "n", v: getByName('Оплата доставки', el.id)});
                }
                return(el);
            });

            SheetData.push(PushedData);
            PushedData = [];

            //Получение "Оплата доставки %"
            if(VisibleResultBlock) {
                if(VisibleTransactionTypeCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                if(VisibleTransactionTypeNonCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                PushedData.push('Оплата доставки %');
                PushedData.push({t: "n", v: getPercentByName('Оплата доставки')});
            }

            CityArrayReport.map((el) => {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Оплата доставки %');
                    PushedData.push({t: "n", v: getPercentByName('Оплата доставки', el.id)});                    
                }
                return(el);
            });

            SheetData.push(PushedData);
            PushedData = [];

            //Получение "Кол-во доставок"
            if(VisibleResultBlock) {
                if(VisibleTransactionTypeCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                if(VisibleTransactionTypeNonCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                PushedData.push('Кол-во доставок');
                PushedData.push({t: "n", v: getNumDelivery()});
            }

            CityArrayReport.map((el) => {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Кол-во доставок')
                    PushedData.push({t: "n", v: getNumDelivery(el.id)});
                }
                return(el)
            });

            SheetData.push(PushedData);
            PushedData = [];

            //Получение "Стоимость 1 доставки"
            if(VisibleResultBlock) {
                if(VisibleTransactionTypeCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                if(VisibleTransactionTypeNonCash) {
                    PushedData.push('');
                    PushedData.push('');
                }

                PushedData.push('Стоимость 1 доставки');
                PushedData.push({t: "n", v: getCostPerDelivery()});
            }

            CityArrayReport.map((el) => {
                if(el.VisibleReport && (!SelectedDirector || el.DirectorID=== SelectedDirector)) {
                    if(VisibleTransactionTypeCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    if(VisibleTransactionTypeNonCash) {
                        PushedData.push('');
                        PushedData.push('');
                    }

                    PushedData.push('Стоимость 1 доставки');
                    PushedData.push({t: "n", v: getCostPerDelivery(el.id)});
                }
                return(el)
            });

            SheetData.push(PushedData);
            PushedData = []; 
        }

        StartExport(SheetData);
    }

    const StartExport = (SheetData) => {
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.aoa_to_sheet(SheetData)

        XLSX.utils.book_append_sheet(wb, ws, 'Авансовый отчет')

        let Name = 'АО ' + String(new Date(SelectedPeriod.Min).getMonth() + 1).padStart(2, '0') + '-' + String(new Date(SelectedPeriod.Min).getFullYear()) + '_' + String(new Date(SelectedPeriod.Max).getMonth() + 1).padStart(2, '0') + '-' + String(new Date(SelectedPeriod.Max).getFullYear())
        
        XLSX.writeFile(wb, Name + '.xlsx')
    }

    const exportReportIndicators = async () => {
        const cities = CityArrayReport.filter((city) => 
            city.VisibleReport && (!SelectedDirector || city.DirectorID === SelectedDirector)
        );
        
        const parsePercent = (percentStr) => {
            if (percentStr === 'NaN %' || !percentStr) return 0;
            const num = parseFloat(percentStr.toString().replace('%', '').trim());
            return isNaN(num) ? 0 : num / 100;
        };

        const logs = cities.map(item => {
            const revenue = parseFloat(getRevenue(item.id));
            const profit = (getSumArticle(null, 'income', null, item.id) - getSumArticle(null, 'expenditure', null, item.id)).toFixed(2)
            const marketString = `Магазин (${selectedMonth.Name})`
            
            return {
                [marketString]: item.City + ' ' + item.Adress,
                'Выручка (руб)': revenue,
                'Закупка (руб)': parseFloat(getByName('Закупка', item.id)) || 0,
                'Закупка (%)': parsePercent(getPercentByName('Закупка', item.id)),
                'ЗП (руб)': parseFloat(getByName('Заработная плата', item.id)) || 0,
                'ЗП (%)': parsePercent(getPercentByName('Заработная плата', item.id)),
                'Доставка (руб)': parseFloat(getByName('Оплата доставки', item.id)) || 0,
                'Цена 1 доставки (руб)': parseFloat(getCostPerDelivery(item.id)) || 0,
                'Доставка (%)': parsePercent(getPercentByName('Оплата доставки', item.id)),
                'Прочие (руб)': parseFloat(getOtherExpenses(item.id)) || 0,
                'Прочие (%)': parsePercent(getOtherExpensesPercent(item.id)),
                'Прибыль (руб)': parseFloat(profit) || 0,
                'Прибыль (%)': revenue > 0 ? (profit / revenue) : 0
            };
        });

        const date = SelectedPeriod.Min.split('-');

        const workbook = new ExcelJS.Workbook();        
        const worksheet = workbook.addWorksheet(`Отчет_${date[1]}.${date[0]}`);

        const headerStyle = {
            fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFE2EFDA' }
            },
            font: {
                bold: true,
                size: 10,
                name: 'Arial'
            },
            alignment: {
                horizontal: 'center',
                vertical: 'middle',
                wrapText: true
            },
            border: {
                top: { style: 'thin', color: { argb: 'FF000000' } },
                left: { style: 'thin', color: { argb: 'FF000000' } },
                bottom: { style: 'thin', color: { argb: 'FF000000' } },
                right: { style: 'thin', color: { argb: 'FF000000' } }
            }
        };

        const dataStyle = {
            font: {
                size: 10,
                name: 'Arial'
            },
            border: {
                top: { style: 'thin', color: { argb: 'FF000000' } },
                left: { style: 'thin', color: { argb: 'FF000000' } },
                bottom: { style: 'thin', color: { argb: 'FF000000' } },
                right: { style: 'thin', color: { argb: 'FF000000' } }
            }
        };

        const headers = Object.keys(logs[0]);
        const headerRow = worksheet.addRow(headers);
        
        headerRow.height = 40;
        
        headerRow.eachCell((cell, colNumber) => {
            Object.assign(cell, headerStyle);
            if (colNumber === 1) {
                cell.border = {
                    top: { style: 'thin', color: { argb: 'FF000000' } },
                    left: { style: 'medium', color: { argb: 'FF000000' } },
                    right: { style: 'medium', color: { argb: 'FF000000' } },
                    bottom: { style: 'thin', color: { argb: 'FF000000' } }
                };
                cell.alignment = {
                    horizontal: 'left',
                    vertical: 'center',
                    wrapText: true
                }
            }
        });

        logs.forEach((log, rowIndex) => {
            const row = worksheet.addRow(Object.values(log));
            const isLastRow = rowIndex === logs.length - 1;

            row.eachCell((cell, colNumber) => {
                Object.assign(cell, dataStyle);

                if (colNumber === 1) {
                    cell.border = {
                        top: { style: 'thin', color: { argb: 'FF000000' } },
                        left: { style: 'medium', color: { argb: 'FF000000' } },
                        right: { style: 'medium', color: { argb: 'FF000000' } },
                        bottom: { style: 'thin', color: { argb: 'FF000000' } }
                    };
                    
                    if (isLastRow) {
                        cell.border = {
                            top: { style: 'thin', color: { argb: 'FF000000' } },
                            left: { style: 'medium', color: { argb: 'FF000000' } },
                            right: { style: 'medium', color: { argb: 'FF000000' } },
                            bottom: { style: 'medium', color: { argb: 'FF000000' } }
                        };
                    }
                }

                if (colNumber > 1) {
                    // Процентные столбцы
                    if ([4, 6, 9, 11, 13].includes(colNumber)) {
                        cell.numFmt = '0.00%';
                        cell.alignment = { 
                            horizontal: 'right',
                            vertical: 'middle'
                        };
                    } 
                    // Числовые столбцы
                    else {
                        cell.numFmt = '#,##0.00';
                        cell.alignment = { 
                            horizontal: 'right',
                            vertical: 'middle'
                        };
                    }
                } else {
                    cell.alignment = { 
                        horizontal: 'left',
                        vertical: 'middle'
                    };
                }
            });
        });

        worksheet.columns = [
            { width: 33 }, // Магазин
            { width: 16 }, // Выручка (руб)
            { width: 16 }, // Закупка (руб)
            { width: 10 }, // Закупка (%)
            { width: 16 }, // ЗП (руб)
            { width: 10 }, // ЗП (%)
            { width: 16 }, // Доставка (руб)
            { width: 16 }, // Цена 1 доставки (руб)
            { width: 10 }, // Доставка (%)
            { width: 16 }, // Прочие (руб)
            { width: 10 }, // Прочие (%)
            { width: 16 }, // Прибыль (руб)
            { width: 10 }  // Прибыль (%)
        ];

        worksheet.views = [
            { state: 'frozen', ySplit: 1 }
        ];

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Отчет_${date[1]}.${date[0]}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    useEffect(() => {    
        getData();
        //eslint-disable-next-line     
    }, []);
    
    useEffect(() => {
        if(!AddAdminArticle && !AddAdminOtherExpenditure) getCityAdvancereportNoLoad();
        //eslint-disable-next-line
    }, [AddAdminArticle, AddAdminOtherExpenditure]);

    useEffect(() => {
        setSearchingCity(UniqueCityArray);
        setSearchingBranch(CityArrayReport);
        checkSelectedAllCity();
        //eslint-disable-next-line
    }, [CityArrayReport, UniqueCityArray]);

    const handleChangeDirectorCity = (value, city) => {
        if(value !== city.DirectorID) {
            setLoadingDirectorChange(false)   
            if(!value) {
                value = null
            } else {
                value = parseInt(value)
            }

            axios.put(Server + 'cities/' + city, { DirectorID: parseFloat(value) }, { headers: { Authorization: 'Bearer ' + User.jwt, }})
            .then(() => { dispatch(changeDirector({idCity: city, DirectorID: value})) })
            .catch(() => {
                document.getElementById('SelectDirector').value = document.getElementById('SelectDirector').defaultValue;
                alert('Ошибка сохранения данных, повторите ввод.');
            })
            .finally(() => {
                setLoadingDirectorChange(true);
            })
        }
    }

    const getCityById = (idCity) => { return CityArrayReport.find(city => city.id === idCity) };

    const isCityVisible = (idCity) => {
        const city = getCityById(idCity);
        return city ? city.VisibleReport : false;
    };

    const isInPeriodByMonthYear = (item, periodMin, periodMax) => {
        const itemMonth = parseFloat(item.MonthValue);
        const itemYear = parseFloat(item.YearValue);
        
        const minDate = new Date(periodMin);
        const maxDate = new Date(periodMax);
        
        const minMonth = parseFloat(minDate.getMonth() + 1);
        const minYear = parseFloat(minDate.getFullYear());
        const maxMonth = parseFloat(maxDate.getMonth() + 1);
        const maxYear = parseFloat(maxDate.getFullYear());
        
        return itemYear >= minYear && itemYear <= maxYear && itemMonth >= minMonth && itemMonth <= maxMonth;
    };

    const isInPeriodByCreateAd = (createAd, periodMin, periodMax) => {
        const date = new Date(createAd);
        const minDate = new Date(periodMin + 'T00:00');
        const maxDate = new Date(periodMax + 'T23:59');
        return date >= minDate && date <= maxDate;
    };

    const sumArticles = (articles, id, type, transactionType, periodMin, periodMax) => {
        return articles.reduce((sum, article) => {
            const matchesConditions = article.Type === type &&
                (!id || article.idArticle === id) &&
                (!transactionType || article.TransactionType === transactionType) &&
                isInPeriodByCreateAd(article.CreateAd, periodMin, periodMax);

            return matchesConditions ? sum + article.Sum : sum;
        }, 0);
    };

    const matchesDirector = (idCity, selectedDirector) => {
        if (!selectedDirector) return true;
        const city = getCityById(idCity);
        return city ? city.DirectorID === selectedDirector : false;
    };

    const itemMatchesAllConditions = (item, selectedDirector, periodMin, periodMax) => {
        return isCityVisible(item.idCity) && matchesDirector(item.idCity, selectedDirector) && isInPeriodByMonthYear(item, periodMin, periodMax);
    };

    const getPercent = (value, sum) => {
        if (!parseFloat(value) || !parseFloat(sum)) return 'NaN %';
        const percent = sum / 100;
        return (value / percent).toFixed(2) + '%';
    };

    const getSumArticle = (id, type, transactionType, idCity) => {
        const reports = idCity ? AdvanceReportED.filter((item) => item.idCity === idCity) : AdvanceReportED;
        if (reports.length === 0) return '0.00';
        
        const { Min: periodMin, Max: periodMax } = SelectedPeriod;
        
        const sum = reports.reduce((totalSum, item) => {
            if (!itemMatchesAllConditions(item, SelectedDirector, periodMin, periodMax)) return totalSum;
            
            const articlesSum = sumArticles(item.Articles, id, type, transactionType, periodMin, periodMax);
            const adminArticlesSum = sumArticles(item.AdminArticles, id, type, transactionType, periodMin, periodMax);
            
            return totalSum + articlesSum + adminArticlesSum;
        }, 0);
        
        return sum.toFixed(2);
    };

    const getRevenue = (idCity) => {
        const reports = idCity ? AdvanceReportED.filter((item) => item.idCity === idCity) : AdvanceReportED;
        if (reports.length === 0) return '0.00';

        const sum = reports.reduce((totalSum, item) => {
            if (!itemMatchesAllConditions(item, SelectedDirector, SelectedPeriod.Min, SelectedPeriod.Max)) return totalSum;

            const filteredArticles = item.Articles.filter((art) => {
                const data = Article.Income.find(el => el.id === art.idArticle)
                if (data && data.isRevenue) return true;
                return false;
            });

            const filteredAdminArticles = item.AdminArticles.filter((art) => {
                const data = Article.Income.find(el => el.id === art.idArticle)
                if (data && data.isRevenue) return true;
                return false;
            });

            const articlesSum = sumArticles(filteredArticles, null, 'income', null, SelectedPeriod.Min, SelectedPeriod.Max);
            const adminArticlesSum = sumArticles(filteredAdminArticles, null, 'income', null, SelectedPeriod.Min, SelectedPeriod.Max);

            return totalSum + articlesSum + adminArticlesSum;
        }, 0).toFixed(2);

        return sum;
    }

    const getRevenueFrontpad = (idCity) => {
        const reports = idCity ? AdvanceReportED.filter((item) => item.idCity === idCity) : AdvanceReportED;
        if (reports.length === 0) return '0.00';
        const sum = reports.reduce((sum, item) => {
            if (!itemMatchesAllConditions(item, SelectedDirector, SelectedPeriod.Min, SelectedPeriod.Max)) return sum;
                return sum + item.RevenueFrontpad;
        }, 0).toFixed(2);
        return sum;
    };

    const getRevenuePercent = (idCity) => {
        const revenue = parseFloat(getRevenue(idCity));
        const revenueFrontpad = parseFloat(getRevenueFrontpad(idCity));
        return ((revenue / revenueFrontpad) - 1).toFixed(2) + '%';
    }

    const getByName = (name, idCity) => {
        const reports = idCity ? AdvanceReportED.filter((item) => item.idCity === idCity) : AdvanceReportED;
        if (reports.length === 0) return '0.00';

        const sum = reports.reduce((totalSum, item) => {
            if (!itemMatchesAllConditions(item, SelectedDirector, SelectedPeriod.Min, SelectedPeriod.Max)) return totalSum;

            const filteredArticles = item.Articles.filter((art) => art.Name === name);
            const filteredAdminArticles = item.AdminArticles.filter((art) => art.Name === name);

            const articlesSum = sumArticles(filteredArticles, null, 'expenditure', null, SelectedPeriod.Min, SelectedPeriod.Max);
            const adminArticlesSum = sumArticles(filteredAdminArticles, null, 'expenditure', null, SelectedPeriod.Min, SelectedPeriod.Max);

          return totalSum + articlesSum + adminArticlesSum;
        }, 0).toFixed(2);

        return sum;
    }

    const getPercentByName = (name, idCity) => {
        const value = parseFloat(getByName(name, idCity));
        const revenue = parseFloat(getRevenue(idCity));
        if (revenue === 0) return '0.00%';
        return getPercent(value, revenue);
    }

    const getOtherExpenses = (idCity) => {
        const reports = idCity ? AdvanceReportED.filter((item) => item.idCity === idCity) : AdvanceReportED;
        if (reports.length === 0) return '0.00';

        const sum = reports.reduce((totalSum, item) => {
            if (!itemMatchesAllConditions(item, SelectedDirector, SelectedPeriod.Min, SelectedPeriod.Max)) return totalSum;

            const filteredArticles = item.Articles.filter((art) => {
                const data = Article.Expenditure.find(el => el.id === art.idArticle)
                if (data && data.OtherExpenditure) return true;
                return false;
            });

            const filteredAdminArticles = item.AdminArticles.filter((art) => {
                const data = Article.Expenditure.find(el => el.id === art.idArticle)
                if (data && data.OtherExpenditure) return true;
                return false;
            });
    
          const articlesSum = sumArticles(filteredArticles, null, 'expenditure', null, SelectedPeriod.Min, SelectedPeriod.Max);
          const adminArticlesSum = sumArticles(filteredAdminArticles, null, 'expenditure', null, SelectedPeriod.Min, SelectedPeriod.Max);
    
          return totalSum + articlesSum + adminArticlesSum;
        }, 0).toFixed(2);

        return sum;
    }

    const getOtherExpensesPercent = (idCity) => {
        const otherExpenses = parseFloat(getOtherExpenses(idCity));
        const revenue = parseFloat(getRevenue(idCity));
        
        if (revenue === 0) return '0.00%';
        return getPercent(otherExpenses, revenue);
    }

    const getNumDelivery = (idCity) => {
        const reports = idCity ? AdvanceReportED.filter((item) => item.idCity === idCity) : AdvanceReportED;
        if (reports.length === 0) return '0.00';

        const sum = reports.reduce((sum, item) => {
            if (!itemMatchesAllConditions(item, SelectedDirector, SelectedPeriod.Min, SelectedPeriod.Max)) return sum;
            return sum + item.NumDelivery;
        }, 0).toFixed(0);

        return sum;
    }

    const getCostPerDelivery = (idCity) => {
        const deliveryPayment = parseFloat(getByName('Оплата доставки', idCity));
        const numDelivery = parseFloat(getNumDelivery(idCity));
        
        if (numDelivery === 0) return '0.00';
        return (deliveryPayment / numDelivery).toFixed(2);
    }

    if(!isLoading) return <div className="ModalGlobalDiv"> <div className="BigSpin"/></div>

    return(
        <div className="ModalGlobalDiv"
        onClick={(() => {
            setOpenFilter(false)
            document.getElementById('SearchingInputSummary City').value = ''
            document.getElementById('SearchingInputSummary Director').value = document.getElementById('SearchingInputSummary Director').defaultValue
            document.getElementById('SearchingInputSummary Month').blur()
            setOpenSearchingDirector(false)
            setOpenSearchingCity(false)
            setOpenSearchingMonth(false)
            setSearchingCity(UniqueCityArray)
            setSearchingBranch(CityArrayReport)
            setSearchingDirector(ArrayUsers)
            setOpenDateInput(false)
        })}
        >
            <div className="ARMainDiv Summary">
                <div className="HeadAR Summary" >
                    <div>
                        <input 
                        className={openSearchingMonth ? "SearchingInputAR SummaryReports Director focus" : "SearchingInputAR SummaryReports Director"}
                        id="SearchingInputSummary Month" 
                        placeholder="Выбор месяца"
                        value={renderSelectMonth()}
                        onClick={((event) => {     
                            event.stopPropagation();
                            setOpenFilter(false);
                            document.getElementById('SearchingInputSummary Month').value = '';
                            document.getElementById('SearchingInputSummary City').blur();
                            document.getElementById('SearchingInputSummary Director').blur();
                            setOpenSearchingDirector(false);
                            setOpenSearchingCity(false);
                            SelectDirector(null);                 
                        })}
                        onFocus={(() => {
                            setOpenSearchingMonth(true);
                        })}
                        onBlur={(() => {
                            setSearchingMonth(MonthArrayAR);
                            document.getElementById('SearchingInputSummary Month').value = '';
                        })}
                        onChange={((e) => {
                            var Val = e.target.value.toLowerCase();
                            setSearchingMonth(MonthArrayAR.filter((el) => el.Name.toLowerCase().includes(Val)));
                        })}
                        />
                        {openSearchingMonth &&
                        <div className="SearchingARMainDiv" >
                            <div className="SearchingARContainer SummaryReports Director">
                                <button className="SelectorOneMonthButton"
                                onClick={((event) => {
                                    event.stopPropagation();
                                    setSelectedMonth(null);
                                    setOpenDateInput(true);
                                    setOpenSearchingMonth(false);
                                    document.getElementById('SearchingInputSummary Month').blur();
                                })}>
                                    Период
                                </button>
                                {searchingMonth.map((el) => 
                                    <button key={el.id} className="SelectorOneMonthButton" id={'SelectorOneMonthButton' + el.id}
                                    onClick={(async () => {                                 
                                        setSelectedMonth(el)
                                        SelectPeriod({Min: `${el.YearValue}-${String(el.MonthValue).padStart(2, '0')}-01`, Max: `${el.YearValue}-${String(el.MonthValue).padStart(2, '0')}-${checkMaxDatePeriod(el.MonthValue, el.YearValue)}`})
                                    })}>
                                        <div> {el.Name} </div>
                                    </button>
                                    )}
                            </div>
                        </div>
                        }
                        {openDateInput &&
                        <div className="SearchingARMainDiv" onClick={(event) => {event.stopPropagation()}} >
                            <div className="SearchingARContainer SummaryReports" style={{ padding: '10px', width: 'auto' }}>                            
                            Период с
                                <div>
                                    <div>
                                    <input
                                    className="ChoicePeriodInput AR"
                                    id="ChoicePeriodInput Min"
                                    type="date"
                                    value={SelectedPeriod.Min}
                                    min={DatePeriodForInput.Min}
                                    max={DatePeriodForInput.Max}
                                    onChange={((e) => {
                                        if(new Date(e.target.value) < new Date(SelectedPeriod.Max))                                
                                            return(SelectPeriod({Min: e.target.value, Max: SelectedPeriod.Max}))
                                        SelectPeriod({Min: SelectedPeriod.Max, Max: SelectedPeriod.Max})                            
                                    })}
                                    />   
                                    </div>
                                    <div> {'по '} </div>
                                    <div>                                    
                                    <input
                                    className="ChoicePeriodInput AR"
                                    id="ChoicePeriodInput Max"
                                    type="date"
                                    value={SelectedPeriod.Max}
                                    min={DatePeriodForInput.Min}
                                    max={DatePeriodForInput.Max}
                                    onChange={((e) => {
                                        if(new Date(e.target.value) > new Date(SelectedPeriod.Min))
                                            return(SelectPeriod({Max: e.target.value, Min: SelectedPeriod.Min}))
                                        SelectPeriod({Max: SelectedPeriod.Min, Min: SelectedPeriod.Min})
                                    })}
                                    />   
                                    </div>
                                    <button className="ButtonArticle" style={{ marginTop: '5px' }}
                                    onClick={(() => {setOpenDateInput(false)})}
                                    >
                                        Закрыть
                                    </button>
                                </div>
                            </div>
                        </div>
                        }
                    </div>                     

                    <div>
                        {(!SelectedAllCity || SelectedAllCity === 'indeterminate') &&
                            <div className="FilterCircleDiv City"> <div className="FilterCircle"/></div>
                        }
                        <input
                        className={openSearchingCity ? "SearchingInputAR SummaryReports focus" : "SearchingInputAR SummaryReports"}
                        placeholder="Выбор филиалов"
                        id='SearchingInputSummary City'
                        onClick={((event) => {     
                            event.stopPropagation()                      
                            setOpenFilter(false)    
                            document.getElementById('SearchingInputSummary City').value = ''
                            document.getElementById('SearchingInputSummary Director').blur()
                            setOpenSearchingDirector(false)
                            SelectDirector(null)
                        })}
                        onFocus={(() => {
                            setOpenSearchingCity(true)
                        })}
                        onChange={((e) => {
                            var Val = e.target.value.toLowerCase()
                            
                            setSearchingCity(UniqueCityArray.filter((el) => 
                                el.ManyBranches ||
                                el.City.toLowerCase().includes(Val)
                            ))

                            setSearchingBranch(CityArrayReport.filter((el) => 
                                (el.City + ' ' + el.Adress).toLowerCase().includes(Val)
                            ))
                        })}
                        />
                        {openSearchingCity && 
                        <div className="SearchingARMainDiv">
                            <div className="SearchingARContainer SummaryReports">
                                <button className="SearchingAROneCity Summary"
                                onClick={((event) => {
                                    event.stopPropagation()
                                    if(SelectedAllCity || SelectedAllCity === 'indeterminate') dispatch(changeVisibleReportAllCity(false));
                                    if(!SelectedAllCity) dispatch(changeVisibleReportAllCity(true));
                                })}
                                >
                                    <div className={SelectedAllCity ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}>
                                        {SelectedAllCity === 'indeterminate' && <div className="ChekerEnteringDataARIndeterminate"/>}
                                        {SelectedAllCity !== 'indeterminate' && <FaCheck className={SelectedAllCity ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>}
                                    </div>
                                    <div className="SearchingAROneCityName"> Все филиалы </div>
                                </button>
                                {SearchingCity.map((el) => 
                                (!el.ManyBranches || SearchingBranch.filter((a) => a.City === el.City).length > 0) &&
                                <>
                                <button key={el.id} className="SearchingAROneCity Summary"
                                onClick={((event) => {
                                    event.stopPropagation()  
                                    dispatch(changeVisibleReportOneCity(el.City))
                                    document.getElementById('SearchingInputSummary City').value = ''
                                })}
                                >
                                    <div className={(el.VisibleReportCity || el.VisibleReportCity === 'indeterminate') ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}>
                                        {el.VisibleReportCity === 'indeterminate' && <div className="ChekerEnteringDataARIndeterminate"/>}
                                        {el.VisibleReportCity !== 'indeterminate' && <FaCheck className={el.VisibleReportCity ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>}
                                    </div>
                                    <div className="SearchingAROneCityName"> {el.City} </div>
                                </button>
                                {el.ManyBranches && SearchingBranch.map((a) => a.City === el.City &&
                                <button key={a.id} className="SearchingAROneCity SummaryAdress"
                                onClick={(async (event) => {
                                    event.stopPropagation()  
                                    dispatch(changeVisibleReportOneBranch(a.id))
                                    document.getElementById('SearchingInputSummary City').value = ''
                                })}
                                >
                                    <div className={a.VisibleReport ? "ChekerEnteringDataAR Mini Active" : "ChekerEnteringDataAR Mini"}>
                                        <FaCheck className={a.VisibleReport ? "ChekerEnteringDataARIcon Mini Active" : "ChekerEnteringDataARIcon Mini"}/>
                                    </div>
                                    <div className="SearchingAROneCityName"> {a.Adress} </div>                                        
                                </button>
                                )}
                                </>
                                )}
                            </div>
                        </div>
                        }
                    </div>
                    
                    <div>
                        <input
                        className={openSearchingDirector ? "SearchingInputAR SummaryReports Director focus" : "SearchingInputAR SummaryReports Director"}
                        placeholder="Выбор директора"
                        id='SearchingInputSummary Director'
                        defaultValue={SelectedDirector ? ArrayUsers.find((el) => el.id === SelectedDirector).FIO : ''}
                        onClick={((event) => {     
                            event.stopPropagation()                      
                            setOpenFilter(false)    
                            setOpenSearchingCity(false)
                            setOpenSearchingMonth(false)
                            dispatch(changeVisibleReportAllCity(true))
                            document.getElementById('SearchingInputSummary Director').value = ''
                        })}
                        onFocus={(() => {
                            setOpenSearchingDirector(true)
                        })}
                        onChange={((e) => {
                            var Val = e.target.value.toLowerCase()                            
                            setSearchingDirector(ArrayUsers.filter((el) => 
                                el.FIO.toLowerCase().includes(Val)
                            ))
                        })}
                        onBlur={(() => {
                            document.getElementById('SearchingInputSummary Director').value = document.getElementById('SearchingInputSummary Director').defaultValue
                        })}
                        />
                        {openSearchingDirector && 
                        <div className="SearchingARMainDiv">
                            <div className="SearchingARContainer SummaryReports Director">
                                <button className="SearchingAROneCity Summary Director"
                                onClick={((event) => {
                                    event.stopPropagation()  
                                    SelectDirector(null)
                                    document.getElementById('SearchingInputSummary Director').defaultValue = ''
                                    document.getElementById('SearchingInputSummary Director').value = document.getElementById('SearchingInputSummary Director').defaultValue
                                    document.getElementById('SearchingInputSummary Director').blur()
                                    setOpenSearchingDirector(false)
                                    setSearchingDirector(ArrayUsers)
                                })}
                                >
                                        Показать все
                                </button>
                                {SearchingDirector.map((el) => 
                                <button key={el.id} className="SearchingAROneCity Summary Director"
                                onClick={((event) => {
                                    event.stopPropagation()  
                                    document.getElementById('SearchingInputSummary Director').defaultValue = el.FIO
                                    document.getElementById('SearchingInputSummary Director').value = document.getElementById('SearchingInputSummary Director').defaultValue
                                    SelectDirector(el.id)
                                    document.getElementById('SearchingInputSummary Director').blur()
                                    setOpenSearchingDirector(false)
                                    setSearchingDirector(ArrayUsers)
                                })}
                                >
                                        {el.FIO}
                                </button>
                                )}
                            </div>
                        </div>
                        }
                    </div>

                    <div className="SummaryReportsHeadButtonsDiv">                    
                        <div>
                            {(!VisibleTransactionTypeCash || !VisibleTransactionTypeNonCash || !VisibleResult) &&
                                <div className="FilterCircleDiv" > <div className="FilterCircle"/> </div>
                            }
                            <button className="FilterButtonAR"
                            onClick={((event) => {
                                event.stopPropagation()
                                setOpenSearchingCity(false)
                                setOpenSearchingDirector(false)
                                setOpenSearchingMonth(false)
                                setOpenFilter(!openFilter)
                            })}>                               
                                <FaFilter />
                            </button>
                            {openFilter &&
                            <div className="FilterARMainDiv">
                                <div className="FilterARContainer AR" >
                                        <button className="CheckBoxEnteringDataAR FirstCash"
                                        onClick={((event) => {
                                            event.stopPropagation(); 
                                            setVisibleTransactionTypeCash(!VisibleTransactionTypeCash)
                                        })}>
                                            <div className={VisibleTransactionTypeCash ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}>
                                                <FaCheck className={VisibleTransactionTypeCash ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                            </div>
                                            <div> Показать нал. </div>
                                        </button>
                                        <button className="CheckBoxEnteringDataAR"
                                        onClick={((event) => {
                                            event.stopPropagation(); 
                                            setVisibleTransactionTypeNonCash(!VisibleTransactionTypeNonCash)
                                        })}
                                        >
                                            <div className={VisibleTransactionTypeNonCash ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}>
                                                <FaCheck className={VisibleTransactionTypeNonCash ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                            </div>
                                            <div> Показать безнал. </div>
                                        </button>       
                                        <button className="CheckBoxEnteringDataAR"
                                        onClick={((event) => {
                                            event.stopPropagation(); 
                                            setVisibleResult(!VisibleResult)
                                        })}>
                                            <div className={VisibleResult ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}>
                                                <FaCheck className={VisibleResult ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                            </div>
                                            <div> Показать итого </div>
                                        </button>        
                                        <button className="CheckBoxEnteringDataAR"
                                        onClick={((event) => {
                                            event.stopPropagation(); 
                                            setVisibleResultBlock(!VisibleResultBlock)
                                        })}>
                                            <div className={VisibleResultBlock ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}>
                                                <FaCheck className={VisibleResultBlock ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                            </div>
                                            <div> Показать свод. </div>
                                        </button>                       
                                </div>
                            </div>
                            }                        
                        </div>
                        {
                        (((
                            (
                                parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 1 
                                || 
                                parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 3 
                                || 
                                parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 5 
                                ||
                                parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 7 
                                || 
                                parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 8 
                                || 
                                parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 10 
                                || 
                                parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 12
                            )
                            &&
                            new Date(SelectedPeriod.Max).getDate() === 31
                        )
                        ||
                        (
                            (
                                parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 4 
                                || 
                                parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 6 
                                || 
                                parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 9 
                                || 
                                parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 11
                            )
                            &&
                            new Date(SelectedPeriod.Max).getDate() === 30
                        )
                        ||
                        (
                            parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 2
                            &&
                            (
                                (new Date(SelectedPeriod.Max).getFullYear() % 4 === 0 && (new Date(SelectedPeriod.Max).getFullYear() % 100 !== 0 || new Date(SelectedPeriod.Max).getFullYear() % 400 === 0 ))
                                ?
                                new Date(SelectedPeriod.Max).getDate() === 29
                                :
                                new Date(SelectedPeriod.Max).getDate() === 28
                            )
                        ))       
                        &&
                        String(new Date(SelectedPeriod.Min).getDate()).padStart(2, '0') === '01')    
                        &&
                        <>
                            <button onClick={handleClickExport} className="FilterButtonAR"><FaFileExcel/></button>
                            <button onClick={exportReportIndicators} className="ButtonArticle"> Показатели </button>
                        </>
                        }
                        
                    </div>
                </div>

                <div className="SummaryReportsCityDiv">
                    {VisibleResultBlock && 
                    <>
                        {VisibleTransactionTypeCash &&
                            <div className="SummaryReportsOneCityDiv">
                                <div className="SummaryReportsHeadOneCityDiv">
                                    <div className="SummaryReportsTransactionTypeDiv"> Нал </div>
                                    <div> Свод </div>
                                    <div> Итог </div>
                                </div>
                                <div className="SummaryReportsResultMainDiv">
                                    <div className={OpenIncomeArticlesCashResultBlock ? "SummaryReportsResultDiv Active income" : "SummaryReportsResultDiv income"} onClick={(() => {setOpenIncomeArticlesCashResultBlock(!OpenIncomeArticlesCashResultBlock)})}>
                                        <FaPlay className={OpenIncomeArticlesCashResultBlock ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                        {'Доход: '}
                                        {getSumArticle(null, 'income', 'Cash')}
                                    </div>
                                    {OpenIncomeArticlesCashResultBlock &&
                                    <div className='SummaryReportsArticlesInfDiv' >
                                        {Article.Income.map((article) => 
                                        (article.TransactionType === 'Cash' || article.TransactionType === 'All') &&
                                        <div className="SummaryReportsOneArticleDiv NoHover">
                                            <div className="SummaryReportsOneArticleName">
                                                {article.Name}
                                            </div>
                                            <div className="SummaryReportsOneArticleSum">                                            
                                                {getSumArticle(article.id, 'income', 'Cash')}
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                    }
                                </div>
                                <div className="SummaryReportsResultMainDiv" >
                                    <div className={OpenExpenditureArticlesCashResultBlock ? "SummaryReportsResultDiv Active expenditure" : "SummaryReportsResultDiv expenditure"} onClick={(() => {setOpenExpenditureArticlesCashResultBlock(!OpenExpenditureArticlesCashResultBlock)})}>
                                        <FaPlay className={OpenExpenditureArticlesCashResultBlock  ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                        {'Расход: '}
                                        {getSumArticle(null, 'expenditure', 'Cash')}
                                    </div>
                                    {OpenExpenditureArticlesCashResultBlock &&
                                    <div className='SummaryReportsArticlesInfDiv'>
                                        {Article.Expenditure.map((article) => 
                                        (article.TransactionType === 'Cash' || article.TransactionType === 'All') &&
                                        <div className="SummaryReportsOneArticleDiv NoHover">
                                            <div className="SummaryReportsOneArticleName">
                                                {article.Name} 
                                            </div>
                                            <div className="SummaryReportsOneArticleSum">
                                                {getSumArticle(article.id, 'expenditure', 'Cash')}
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                    }
                                </div>
                                <div className="SummaryReportsResultMainDiv">
                                    <div className="SummaryReportsResultDiv collection Final">
                                        {'Внесение "+"/Инкассация "-": '}
                                        {getSumArticle(null, 'collection', 'Cash')}                                
                                    </div>                                    
                                </div>
                                <div className="SummaryReportsResultDiv result Final">
                                    {'Остаток: '}
                                    {(getSumArticle(null, 'income', 'Cash') - getSumArticle(null, 'expenditure', 'Cash')).toFixed(2)}
                                </div>
                            </div>
                        }
                        {VisibleTransactionTypeNonCash &&
                            <div className="SummaryReportsOneCityDiv">
                                <div className="SummaryReportsHeadOneCityDiv">
                                    <div className="SummaryReportsTransactionTypeDiv"> Безнал </div>
                                    <div> Свод </div>
                                    <div> Итог </div>
                                </div>
                                <div className="SummaryReportsResultMainDiv">
                                    <div className={OpenIncomeArticlesNonCashResultBlock ? "SummaryReportsResultDiv Active income" : "SummaryReportsResultDiv income"} onClick={(() => {setOpenIncomeArticlesNonCashResultBlock(!OpenIncomeArticlesNonCashResultBlock)})}>
                                        <FaPlay className={OpenIncomeArticlesNonCashResultBlock ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                        {'Доход: '}
                                        {getSumArticle(null, 'income', 'NonCash')}
                                    </div>
                                    {OpenIncomeArticlesNonCashResultBlock &&
                                    <div className='SummaryReportsArticlesInfDiv'>
                                        {Article.Income.map((article) => 
                                        (article.TransactionType === 'NonCash' || article.TransactionType === 'All') &&
                                        <div className="SummaryReportsOneArticleDiv NoHover">
                                            <div className="SummaryReportsOneArticleName">
                                                {article.Name}
                                            </div>
                                            <div className="SummaryReportsOneArticleSum">
                                                {getSumArticle(article.id, 'income', 'NonCash')}
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                    }
                                </div>
                                <div className="SummaryReportsResultMainDiv">
                                    <div className={OpenExpenditureArticlesNonCashResultBlock ? "SummaryReportsResultDiv Active expenditure" : "SummaryReportsResultDiv expenditure"} onClick={(() => {setOpenExpenditureArticlesNonCashResultBlock(!OpenExpenditureArticlesNonCashResultBlock)})}>
                                        <FaPlay className={OpenExpenditureArticlesNonCashResultBlock ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                        {'Расход: '}
                                        {getSumArticle(null, 'expenditure', 'NonCash')}
                                    </div>
                                    {OpenExpenditureArticlesNonCashResultBlock &&
                                    <div className='SummaryReportsArticlesInfDiv'>
                                        {Article.Expenditure.map((article) => 
                                        (article.TransactionType === 'NonCash' || article.TransactionType === 'All') &&
                                        <div className="SummaryReportsOneArticleDiv NoHover">
                                            <div className="SummaryReportsOneArticleName">
                                                {article.Name}
                                            </div>
                                            <div className="SummaryReportsOneArticleSum">                                            
                                                {getSumArticle(article.id, 'expenditure', 'NonCash')}
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                    }
                                </div>
                                <div className="SummaryReportsResultDiv collection Final">
                                    {'Внесение "+"/Инкассация "-": '}
                                    {getSumArticle(null, 'collection', 'NonCash')}                               
                                </div>    
                                <div className="SummaryReportsResultDiv result Final">
                                    {'Остаток: '}
                                    {(getSumArticle(null, 'income', 'NonCash') - getSumArticle(null, 'expenditure', 'NonCash')).toFixed(2)}                               
                                </div>
                            </div>
                        }
                        {VisibleResult &&
                            <div className="SummaryReportsOneCityDiv">
                                <div className="SummaryReportsHeadOneCityDiv">
                                    <div className="SummaryReportsTransactionTypeDiv"> Итого </div>
                                    <div> Свод </div>
                                    <div> Итог </div>
                                </div>
                                <div className="SummaryReportsResultMainDiv">
                                    <div className={OpenIncomeArticlesResultResultBlock ? "SummaryReportsResultDiv Active income" : "SummaryReportsResultDiv income"} onClick={(() => {setOpenIncomeArticlesResultResultBlock(!OpenIncomeArticlesResultResultBlock)})}>
                                        <FaPlay className={OpenIncomeArticlesResultResultBlock ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                        {'Доход: '}
                                        {getSumArticle(null, 'income')}
                                    </div>
                                    {OpenIncomeArticlesResultResultBlock &&
                                    <div className='SummaryReportsArticlesInfDiv'>
                                        {Article.Income.map((article) =>                                     
                                        <div className="SummaryReportsOneArticleDiv NoHover">
                                            <div className="SummaryReportsOneArticleName">
                                                {article.Name}
                                            </div>
                                            <div className="SummaryReportsOneArticleSum">                                            
                                                {getSumArticle(article.id, 'income')}
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                    }
                                </div>
                                <div className="SummaryReportsResultMainDiv">
                                    <div className={OpenExpenditureArticlesResultResultBlock ? "SummaryReportsResultDiv Active expenditure" : "SummaryReportsResultDiv expenditure"} onClick={(() => {setOpenExpenditureArticlesResultResultBlock(!OpenExpenditureArticlesResultResultBlock)})}>
                                        <FaPlay className={OpenExpenditureArticlesResultResultBlock ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                        {'Расход: '}
                                        {getSumArticle(null, 'expenditure')}
                                    </div>
                                    {OpenExpenditureArticlesResultResultBlock &&
                                    <div className='SummaryReportsArticlesInfDiv'>
                                        {Article.Expenditure.map((article) =>
                                        <div className="SummaryReportsOneArticleDiv NoHover">
                                            <div className="SummaryReportsOneArticleName">
                                                {article.Name}
                                            </div>
                                            <div className="SummaryReportsOneArticleSum">                                            
                                                {`${getSumArticle(article.id, 'expenditure')} (${getPercent(getSumArticle(article.id, 'expenditure'), getSumArticle(null, 'income'))})`}
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                    }
                                </div>
                                <div className="SummaryReportsResultDiv collection Final">
                                    {'Внесение "+"/Инкассация "-": '}
                                    {getSumArticle(null, 'collection')}                               
                                </div>    
                                <div className="SummaryReportsResultDiv result Final">
                                    {'Остаток: '}
                                    {(getSumArticle(null, 'income') - getSumArticle(null, 'expenditure')).toFixed(2)}                               
                                </div>
                                {
                                (((
                                    (
                                        parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 1 
                                        || 
                                        parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 3 
                                        || 
                                        parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 5 
                                        ||
                                        parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 7 
                                        || 
                                        parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 8 
                                        || 
                                        parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 10 
                                        || 
                                        parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 12
                                    )
                                    &&
                                    new Date(SelectedPeriod.Max).getDate() === 31
                                )
                                ||
                                (
                                    (
                                        parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 4 
                                        || 
                                        parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 6 
                                        || 
                                        parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 9 
                                        || 
                                        parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 11
                                    )
                                    &&
                                    new Date(SelectedPeriod.Max).getDate() === 30
                                )
                                ||
                                (
                                    parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 2
                                    &&
                                    (
                                        (new Date(SelectedPeriod.Max).getFullYear() % 4 === 0 && (new Date(SelectedPeriod.Max).getFullYear() % 100 !== 0 || new Date(SelectedPeriod.Max).getFullYear() % 400 === 0 ))
                                        ?
                                        new Date(SelectedPeriod.Max).getDate() === 29
                                        :
                                        new Date(SelectedPeriod.Max).getDate() === 28
                                    )
                                ))       
                                &&
                                String(new Date(SelectedPeriod.Min).getDate()).padStart(2, '0') === '01')    
                                &&
                                <div className="SummaryReportsResultMainDiv">
                                    <div className={OpenBackgroundInformationResultBlock ? "SummaryReportsResultDiv Active BackgroundInformation" : "SummaryReportsResultDiv BackgroundInformation"} onClick={(() => {setOpenBackgroundInformationResultBlock(!OpenBackgroundInformationResultBlock)})}>
                                        <FaPlay className={OpenBackgroundInformationResultBlock ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                        {'Справочная информация'}
                                    </div>
                                    
                                        {OpenBackgroundInformationResultBlock &&
                                        <div className='SummaryReportsArticlesInfDiv'>
                                            {new Date(SelectedPeriod.Max).getMonth() === new Date(SelectedPeriod.Min).getMonth() &&
                                            <>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText">
                                                        Нал
                                                    </div>
                                                    
                                                    <div className="SummaryReportsInformationText">
                                                        {AdvanceReportED.length > 0 &&
                                                        AdvanceReportED.reduce((Sum, item) => 
                                                        (CityArrayReport.map((city) => {
                                                            if(city.id === item.idCity)
                                                                return(city.VisibleReport)
                                                            return undefined
                                                        }).filter((a) => a !== undefined)[0]
                                                        &&
                                                        (!SelectedDirector || CityArrayReport.map((city) => {
                                                            if(city.id === item.idCity)
                                                                return(city.DirectorID)
                                                            return undefined
                                                        }).filter((a) => a !== undefined)[0] === SelectedDirector)
                                                        &&
                                                        parseFloat(item.MonthValue) >= parseFloat(new Date(SelectedPeriod.Min).getMonth() + 1)
                                                        &&
                                                        parseFloat(item.MonthValue) <= parseFloat(new Date(SelectedPeriod.Max).getMonth() + 1)
                                                        && 
                                                        parseFloat(item.YearValue) >= parseFloat(new Date(SelectedPeriod.Min).getFullYear())
                                                        &&
                                                        parseFloat(item.YearValue) <= parseFloat(new Date(SelectedPeriod.Max).getFullYear())
                                                        )
                                                        ?
                                                        Sum + item.AdminSumCash
                                                        :
                                                        Sum + 0, 0
                                                        ).toFixed(2)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Безнал </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {AdvanceReportED.length > 0 &&
                                                        AdvanceReportED.reduce((Sum, item) => 
                                                        (CityArrayReport.map((city) => {
                                                            if(city.id === item.idCity)
                                                                return(city.VisibleReport)
                                                            return undefined
                                                        }).filter((a) => a !== undefined)[0]
                                                        &&
                                                        (!SelectedDirector || CityArrayReport.map((city) => {
                                                            if(city.id === item.idCity)
                                                                return(city.DirectorID)
                                                            return undefined
                                                        }).filter((a) => a !== undefined)[0] === SelectedDirector)
                                                        &&
                                                        parseFloat(item.MonthValue) >= parseFloat(new Date(SelectedPeriod.Min).getMonth() + 1)
                                                        &&
                                                        parseFloat(item.MonthValue) <= parseFloat(new Date(SelectedPeriod.Max).getMonth() + 1)
                                                        && 
                                                        parseFloat(item.YearValue) >= parseFloat(new Date(SelectedPeriod.Min).getFullYear())
                                                        &&
                                                        parseFloat(item.YearValue) <= parseFloat(new Date(SelectedPeriod.Max).getFullYear())
                                                        )
                                                        ?
                                                        Sum + item.AdminSumNonCash
                                                        :
                                                        Sum + 0, 0
                                                        ).toFixed(2)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Итого </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {AdvanceReportED.length > 0 &&
                                                        AdvanceReportED.reduce((Sum, item) => 
                                                        (CityArrayReport.map((city) => {
                                                            if(city.id === item.idCity)
                                                                return(city.VisibleReport)
                                                            return undefined
                                                        }).filter((a) => a !== undefined)[0]
                                                        &&
                                                        (!SelectedDirector || CityArrayReport.map((city) => {
                                                            if(city.id === item.idCity)
                                                                return(city.DirectorID)
                                                            return undefined
                                                        }).filter((a) => a !== undefined)[0] === SelectedDirector)
                                                        &&
                                                        parseFloat(item.MonthValue) >= parseFloat(new Date(SelectedPeriod.Min).getMonth() + 1)
                                                        &&
                                                        parseFloat(item.MonthValue) <= parseFloat(new Date(SelectedPeriod.Max).getMonth() + 1)
                                                        && 
                                                        parseFloat(item.YearValue) >= parseFloat(new Date(SelectedPeriod.Min).getFullYear())
                                                        &&
                                                        parseFloat(item.YearValue) <= parseFloat(new Date(SelectedPeriod.Max).getFullYear())
                                                        )
                                                        ?
                                                        Sum + item.AdminSumNonCash + item.AdminSumCash
                                                        :
                                                        Sum + 0, 0
                                                        ).toFixed(2)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Остаток </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {AdvanceReportED.length > 0 &&
                                                        AdvanceReportED.reduce((Sum, item) => 
                                                        (CityArrayReport.map((city) => {
                                                            if(city.id === item.idCity)
                                                                return(city.VisibleReport)
                                                            return undefined
                                                        }).filter((a) => a !== undefined)[0]
                                                        &&
                                                        (!SelectedDirector || CityArrayReport.map((city) => {
                                                            if(city.id === item.idCity)
                                                                return(city.DirectorID)
                                                            return undefined
                                                        }).filter((a) => a !== undefined)[0] === SelectedDirector)
                                                        &&
                                                        parseFloat(item.MonthValue) >= parseFloat(new Date(SelectedPeriod.Min).getMonth() + 1)
                                                        &&
                                                        parseFloat(item.MonthValue) <= parseFloat(new Date(SelectedPeriod.Max).getMonth() + 1)
                                                        && 
                                                        parseFloat(item.YearValue) >= parseFloat(new Date(SelectedPeriod.Min).getFullYear())
                                                        &&
                                                        parseFloat(item.YearValue) <= parseFloat(new Date(SelectedPeriod.Max).getFullYear())
                                                        )
                                                        ?
                                                        Sum + ((item.AdminSumNonCash + item.AdminSumCash) * (item.PercentRemains/100))
                                                        :
                                                        Sum + 0, 0
                                                        ).toFixed(2)}
                                                    </div>
                                                </div>
                                            </>
                                            }
                                            <div className="SummaryReportsBackgroundInformation">
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Выручка ФП </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getRevenueFrontpad()}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Выручка </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getRevenue()}
                                                    </div>
                                                </div>
                                                <div
                                                className="SummaryReportsOneInformationDiv"
                                                >
                                                    <div className="SummaryReportsInformationText">
                                                        Выручка %
                                                    </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getRevenuePercent()}
                                                    </div>
                                                </div>
                                                <div
                                                className="SummaryReportsOneInformationDiv"
                                                >
                                                    <div className="SummaryReportsInformationText"> Закупка </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getByName('Закупка')}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Закупка % </div>
                                                    <div
                                                    className="SummaryReportsInformationText"
                                                    >
                                                        {getPercentByName('Закупка')}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Заработная плата </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getByName('Заработная плата')}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Заработная плата % </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getPercentByName('Заработная плата')}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Прочие расходы </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getOtherExpenses()}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Прочие расходы % </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getOtherExpensesPercent()}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Оплата доставки </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getByName('Оплата доставки')}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Оплата доставки % </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getPercentByName('Оплата доставки')}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Кол-во доставок </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getNumDelivery()}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Стоимость 1 доставки </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getCostPerDelivery()}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    
                                </div>
                                }
                            </div>
                        }
                    </>
                    }
                    {CityArrayReport && CityArrayReport.map((el) => 
                    el.VisibleReport && (!SelectedDirector || el.DirectorID === SelectedDirector) &&
                    <>
                        {VisibleTransactionTypeCash &&
                        <div className="SummaryReportsOneCityDiv">
                            <div className="SummaryReportsHeadOneCityDiv">
                                <div className="SummaryReportsTransactionTypeDiv"> Нал </div>
                                <div> {el.City} </div>
                                <div> {el.Adress} </div>
                            </div>
                            <div className="SummaryReportsResultMainDiv">
                                <div className={el.OpenIncomeArticlesCash ? "SummaryReportsResultDiv Active income" : "SummaryReportsResultDiv income"} onClick={(() => {dispatch(changeCityArrayReportOpenInf({id: el.id, Type: 'income Cash'}))})}>
                                    <FaPlay className={el.OpenIncomeArticlesCash ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                    {'Доход: '}
                                    {getSumArticle(null, 'income', 'Cash', el.id)}
                                </div>
                                {el.OpenIncomeArticlesCash &&
                                <div className='SummaryReportsArticlesInfDiv'>
                                    {Article.Income.map((article) => 
                                    (article.TransactionType === 'Cash' || article.TransactionType === 'All') &&
                                    <div className="SummaryReportsOneArticleDiv"
                                    onClick={(() => {
                                        SelectArticle({id: article.id, idCity: el.id, TransactionType: 'Cash'})
                                        setOpenModalArticles(true)
                                    })}
                                    >
                                        <div className="SummaryReportsOneArticleName">
                                            {article.Name}
                                        </div>
                                        <div className="SummaryReportsOneArticleSum">                                            
                                            {getSumArticle(article.id, 'income', 'Cash', el.id)} 
                                            {[roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && 
                                            <button className="AddAdminArticleButton"
                                            onClick={((event) => {
                                                event.stopPropagation()            
                                                let elCreateAdDate = new Date().getFullYear() + '-' + String(parseFloat(new Date().getMonth()) + 1).padStart(2, '0') + '-' + String(new Date().getDate()).padStart(2, '0')
                                                let elCreateAdTime = String(new Date().getHours()).padStart(2, '0')  + ':' + String(new Date().getMinutes()).padStart(2, '0') 
                                                dispatch(openAddedAdminArticle({
                                                    idArticle: article.id,
                                                    Name: article.Name,
                                                    ResponsibleUserName: User.user.FIO,
                                                    OtherExpenditure: article.OtherExpenditure,
                                                    TransactionType: 'Cash',
                                                    Type: article.Type,
                                                    CreateAdDate: elCreateAdDate,
                                                    CreateAdTime: elCreateAdTime,
                                                    idCity: el.id
                                                }))
                                                dispatch(setOpenAddArticleED(true))
                                            })}
                                            >                               
                                                +
                                            </button>
                                            }
                                        </div>
                                    </div>
                                    )}
                                </div>
                                }
                            </div>
                            <div className="SummaryReportsResultMainDiv" >
                                <div className={el.OpenExpenditureArticlesCash ? "SummaryReportsResultDiv Active expenditure" : "SummaryReportsResultDiv expenditure"} onClick={(() => {dispatch(changeCityArrayReportOpenInf({id: el.id, Type: 'expenditure Cash'}))})}>
                                    <FaPlay className={el.OpenExpenditureArticlesCash ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                    {'Расход: '}
                                    {getSumArticle(null, 'expenditure', 'Cash', el.id)}
                                </div>
                                {el.OpenExpenditureArticlesCash &&
                                <div className='SummaryReportsArticlesInfDiv'>
                                    {Article.Expenditure.map((article) => 
                                    (article.TransactionType === 'Cash' || article.TransactionType === 'All') &&
                                    <>
                                    <div className="SummaryReportsOneArticleDiv"
                                    onClick={(() => {
                                        SelectArticle({id: article.id, idCity: el.id, TransactionType: 'Cash'})
                                        setOpenModalArticles(true)
                                    })}
                                    >
                                        <div className="SummaryReportsOneArticleName">
                                            {article.Name}
                                        </div>
                                        <div className="SummaryReportsOneArticleSum">
                                            {getSumArticle(article.id, 'expenditure', 'Cash', el.id)}
                                            {[roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && 
                                            <button className="AddAdminArticleButton"
                                            onClick={((event) => {
                                                event.stopPropagation()            
                                                let elCreateAdDate = new Date().getFullYear() + '-' + String(parseFloat(new Date().getMonth()) + 1).padStart(2, '0') + '-' + String(new Date().getDate()).padStart(2, '0')
                                                let elCreateAdTime = String(new Date().getHours()).padStart(2, '0') + ':' + String(new Date().getMinutes()).padStart(2, '0') 
                                                dispatch(openAddedAdminArticle({
                                                    idArticle: article.id,
                                                    Name: article.Name,
                                                    ResponsibleUserName: User.user.FIO,
                                                    OtherExpenditure: article.OtherExpenditure,
                                                    TransactionType: 'Cash',
                                                    Type: article.Type,
                                                    CreateAdDate: elCreateAdDate,
                                                    CreateAdTime: elCreateAdTime,
                                                    idCity: el.id
                                                }))
                                                dispatch(setOpenAddArticleED(true))
                                            })}
                                            >                               
                                                +
                                            </button>
                                            }
                                        </div>
                                    </div>
                                    </>
                                    )}
                                </div>
                                }
                            </div>
                            <div className="SummaryReportsResultMainDiv">
                                <div className="SummaryReportsResultDiv collection Final">
                                    {'Внесение "+"/Инкассация "-": '}
                                    {getSumArticle(null, 'collection', 'Cash', el.id)}                                
                                </div>                                    
                            </div>
                            <div className="SummaryReportsResultDiv result Final">
                                {'Остаток: '}
                                {(getSumArticle(null, 'income', 'Cash', el.id) - getSumArticle(null, 'expenditure', 'Cash', el.id)).toFixed(2)}
                            </div>
                        </div>
                        }

                        {VisibleTransactionTypeNonCash &&
                        <div className="SummaryReportsOneCityDiv">
                            <div className="SummaryReportsHeadOneCityDiv">
                                <div className="SummaryReportsTransactionTypeDiv"> Безнал </div>
                                <div> {el.City} </div>
                                <div> {el.Adress} </div>
                            </div>
                            <div className="SummaryReportsResultMainDiv">
                                <div className={el.OpenIncomeArticlesNonCash ? "SummaryReportsResultDiv Active income" : "SummaryReportsResultDiv income"} onClick={(() => {dispatch(changeCityArrayReportOpenInf({id: el.id, Type: 'income NonCash'}))})}>
                                    <FaPlay className={el.OpenIncomeArticlesNonCash ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                    {'Доход: '}
                                    {getSumArticle(null, 'income', 'NonCash', el.id)}
                                </div>
                                {el.OpenIncomeArticlesNonCash &&
                                <div className='SummaryReportsArticlesInfDiv'>
                                    {Article.Income.map((article) => 
                                    (article.TransactionType === 'NonCash' || article.TransactionType === 'All') &&
                                    <div className="SummaryReportsOneArticleDiv"
                                    onClick={(() => {
                                        SelectArticle({id: article.id, idCity: el.id, TransactionType: 'NonCash'})
                                        setOpenModalArticles(true)
                                    })}
                                    >
                                        <div className="SummaryReportsOneArticleName">
                                            {article.Name}
                                        </div>
                                        <div className="SummaryReportsOneArticleSum">                                            
                                            {getSumArticle(article.id, 'income', 'NonCash', el.id)}
                                            {[roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && 
                                            <button className="AddAdminArticleButton"
                                            onClick={((event) => {
                                                event.stopPropagation()            
                                                let elCreateAdDate = new Date().getFullYear() + '-' + String(parseFloat(new Date().getMonth()) + 1).padStart(2, '0') + '-' + String(new Date().getDate()).padStart(2, '0')
                                                let elCreateAdTime = String(new Date().getHours()).padStart(2, '0') + ':' + String(new Date().getMinutes()).padStart(2, '0') 
                                                dispatch(openAddedAdminArticle({
                                                    idArticle: article.id,
                                                    Name: article.Name,
                                                    ResponsibleUserName: User.user.FIO,
                                                    OtherExpenditure: article.OtherExpenditure,
                                                    TransactionType: 'NonCash',
                                                    Type: article.Type,
                                                    CreateAdDate: elCreateAdDate,
                                                    CreateAdTime: elCreateAdTime,
                                                    idCity: el.id
                                                }))
                                                dispatch(setOpenAddArticleED(true))
                                            })}
                                            >                               
                                                +
                                            </button>
                                            }
                                        </div>
                                    </div>
                                    )}
                                </div>
                                }
                            </div>
                            <div className="SummaryReportsResultMainDiv">
                                <div className={el.OpenExpenditureArticlesNonCash ? "SummaryReportsResultDiv Active expenditure" : "SummaryReportsResultDiv expenditure"} onClick={(() => {dispatch(changeCityArrayReportOpenInf({id: el.id, Type: 'expenditure NonCash'}))})}>
                                    <FaPlay className={el.OpenExpenditureArticlesNonCash ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                    {'Расход: '}
                                    {getSumArticle(null, 'expenditure', 'NonCash', el.id)}
                                </div>
                                {el.OpenExpenditureArticlesNonCash &&
                                <div className='SummaryReportsArticlesInfDiv'>
                                    {Article.Expenditure.map((article) => 
                                    (article.TransactionType === 'NonCash' || article.TransactionType === 'All') &&
                                    <>
                                    <div className="SummaryReportsOneArticleDiv"
                                    onClick={(() => {
                                        SelectArticle({id: article.id, idCity: el.id, TransactionType: 'NonCash'})
                                        setOpenModalArticles(true)
                                    })}
                                    >
                                        <div className="SummaryReportsOneArticleName">
                                            {article.Name}
                                        </div>
                                        <div className="SummaryReportsOneArticleSum">                                            
                                            {getSumArticle(article.id, 'expenditure', 'NonCash', el.id)}
                                            {[roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && 
                                            <button className="AddAdminArticleButton"
                                            onClick={((event) => {
                                                event.stopPropagation()            
                                                let elCreateAdDate = new Date().getFullYear() + '-' + String(parseFloat(new Date().getMonth()) + 1).padStart(2, '0') + '-' + String(new Date().getDate()).padStart(2, '0')
                                                let elCreateAdTime = String(new Date().getHours()).padStart(2, '0') + ':' + String(new Date().getMinutes()).padStart(2, '0') 
                                                dispatch(openAddedAdminArticle({
                                                    idArticle: article.id,
                                                    Name: article.Name,
                                                    ResponsibleUserName: User.user.FIO,
                                                    OtherExpenditure: article.OtherExpenditure,
                                                    TransactionType: 'NonCash',
                                                    Type: article.Type,
                                                    CreateAdDate: elCreateAdDate,
                                                    CreateAdTime: elCreateAdTime,
                                                    idCity: el.id
                                                }))
                                                dispatch(setOpenAddArticleED(true))
                                            })}
                                            >                               
                                                +
                                            </button>
                                            }
                                        </div>
                                    </div>
                                    </>
                                    )}
                                </div>
                                }
                            </div>
                            <div className="SummaryReportsResultMainDiv">
                                <div className="SummaryReportsResultDiv collection Final">
                                    {'Внесение "+"/Инкассация "-": '}
                                    {getSumArticle(null, 'collection', 'NonCash', el.id)}                                
                                </div>                                    
                            </div>
                            <div className="SummaryReportsResultDiv result Final">
                                {'Остаток: '}
                                {(getSumArticle(null, 'income', 'NonCash', el.id) - getSumArticle(null, 'expenditure', 'NonCash', el.id)).toFixed(2)}
                            </div>
                        </div>
                        }

                        {VisibleResult &&
                        <div className="SummaryReportsOneCityDiv">
                            <div className="SummaryReportsHeadOneCityDiv">
                                <div className="SummaryReportsTransactionTypeDiv"> Итого </div>
                                <div>{el.City}</div>
                                <div>{el.Adress}</div>
                            </div>
                            <div className="SummaryReportsResultMainDiv" >
                                <div className={el.OpenIncomeArticlesResult ? "SummaryReportsResultDiv Active income" : "SummaryReportsResultDiv income"} onClick={(() => {dispatch(changeCityArrayReportOpenInf({id: el.id, Type: 'income Result'}))})}>
                                    <FaPlay className={el.OpenIncomeArticlesResult ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                    {'Доход: '}
                                    {getSumArticle(null, 'income', null, el.id)}
                                </div>
                                {el.OpenIncomeArticlesResult &&
                                <div className='SummaryReportsArticlesInfDiv'>
                                    {Article.Income.map((article) =>                                     
                                    <div className="SummaryReportsOneArticleDiv"
                                    onClick={(() => {
                                        SelectArticle({id: article.id, idCity: el.id, TransactionType: 'All'})
                                        setOpenModalArticles(true)
                                    })}
                                    >
                                        <div className="SummaryReportsOneArticleName">
                                            {article.Name}
                                        </div>
                                        <div className="SummaryReportsOneArticleSum">                                            
                                            {getSumArticle(article.id, 'income', null, el.id)}
                                        </div>
                                    </div>
                                    )}
                                </div>
                                }
                            </div>
                            <div className="SummaryReportsResultMainDiv">
                                <div className={el.OpenExpenditureArticlesResult ? "SummaryReportsResultDiv Active expenditure" : "SummaryReportsResultDiv expenditure"} onClick={(() => {dispatch(changeCityArrayReportOpenInf({id: el.id, Type: 'expenditure Result'}))})}>
                                    <FaPlay className={el.OpenExpenditureArticlesResult ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                    {'Расход: '}
                                    {getSumArticle(null, 'expenditure', null, el.id)}                              
                                </div>
                                {el.OpenExpenditureArticlesResult &&
                                <div className='SummaryReportsArticlesInfDiv'>
                                    {Article.Expenditure.map((article) =>
                                    <>
                                        <div className="SummaryReportsOneArticleDiv"
                                        onClick={(() => {
                                            SelectArticle({id: article.id, idCity: el.id, TransactionType: 'All'})
                                            setOpenModalArticles(true)
                                        })}
                                        >
                                        <div className="SummaryReportsOneArticleName">
                                            {article.Name}
                                        </div>
                                        <div className="SummaryReportsOneArticleSum">                                            
                                            {`${getSumArticle(article.id, 'expenditure', null, el.id)} (${getPercent(getSumArticle(article.id, 'expenditure', null, el.id), getSumArticle(null, 'income', null, el.id))})`}
                                        </div>
                                    </div>
                                    </>
                                    )}
                                </div>
                                }
                            </div>
                            <div className="SummaryReportsResultMainDiv">
                                <div className="SummaryReportsResultDiv collection Final">
                                    {'Внесение "+"/Инкассация "-": '}
                                    {getSumArticle(null, 'collection', null, el.id)}                                
                                </div>                                    
                            </div>
                            <div className="SummaryReportsResultDiv result Final">
                                {'Остаток: '}
                                {(getSumArticle(null, 'income', null, el.id) - getSumArticle(null, 'expenditure', null, el.id)).toFixed(2)}
                            </div>
                            {
                            (((
                                (
                                    parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 1 
                                    || 
                                    parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 3 
                                    || 
                                    parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 5 
                                    ||
                                    parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 7 
                                    || 
                                    parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 8 
                                    || 
                                    parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 10 
                                    || 
                                    parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 12
                                )
                                &&
                                new Date(SelectedPeriod.Max).getDate() === 31
                            )
                            ||
                            (
                                (
                                    parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 4 
                                    || 
                                    parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 6 
                                    || 
                                    parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 9 
                                    || 
                                    parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 11
                                )
                                &&
                                new Date(SelectedPeriod.Max).getDate() === 30
                            )
                            ||
                            (
                                parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1 === 2
                                &&
                                (
                                    (new Date(SelectedPeriod.Max).getFullYear() % 4 === 0 && (new Date(SelectedPeriod.Max).getFullYear() % 100 !== 0 || new Date(SelectedPeriod.Max).getFullYear() % 400 === 0 ))
                                    ?
                                    new Date(SelectedPeriod.Max).getDate() === 29
                                    :
                                    new Date(SelectedPeriod.Max).getDate() === 28
                                )
                            ))       
                            &&
                            String(new Date(SelectedPeriod.Min).getDate()).padStart(2, '0') === '01')    
                            &&
                            <div className="SummaryReportsResultMainDiv">
                                <div className={el.OpenBackgroundInformation ? "SummaryReportsResultDiv Active BackgroundInformation" : "SummaryReportsResultDiv BackgroundInformation"} onClick={(() => {dispatch(changeCityArrayReportOpenInf({id: el.id, Type: 'BackgroundInformation'}))})}>
                                    
                                    <FaPlay className={el.OpenBackgroundInformation ? 'SummaryReportsResultIcon Active' : 'SummaryReportsResultIcon'}/>
                                    {'Справочная информация'}
                                </div>
                                {el.OpenBackgroundInformation &&
                                    <div className='SummaryReportsArticlesInfDiv'>
                                        {
                                            new Date(SelectedPeriod.Max).getMonth() === new Date(SelectedPeriod.Min).getMonth()
                                            ?
                                            <div className="SummaryReportsBackgroundInformation">
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Директор </div>
                                                    <select  className="SummaryReportsInformationInput" id='SelectDirector'                                                    
                                                    defaultValue={el.DirectorID 
                                                        ? ArrayUsers.find((user) => user.id === el.DirectorID) ? ArrayUsers.find((user) => user.id === el.DirectorID).id : '' 
                                                        : ''}                                                    
                                                    onChange={((e) => { handleChangeDirectorCity(e.target.value, el.id)})}
                                                    >
                                                        <option value=''> - </option>
                                                        {ArrayUsers.map((item) => <option value={item.id}> {item.FIO} </option>)}
                                                    </select> 
                                                    {!isLoadingDirectorChange && <div className="MiniSpinSummaryResultDiv"> <div className="MiniSpinSummaryResult"/> </div>}
                                                </div>

                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText">
                                                        Нал
                                                    </div>
                                                    <input
                                                    type="number"
                                                    className="SummaryReportsInformationInput"
                                                    id='SummaryReportsInformationInput AdminSumCash'
                                                    defaultValue={AdvanceReportED.filter((item) => 
                                                        item.idCity === el.id 
                                                        &&
                                                        parseFloat(item.MonthValue) === parseFloat(new Date(SelectedPeriod.Min).getMonth() + 1)
                                                        &&
                                                        parseFloat(item.YearValue) === parseFloat(new Date(SelectedPeriod.Min).getFullYear())
                                                        )[0].AdminSumCash}
                                                    onFocus={(() => {if(User.user.role.id === roleId.director) document.getElementById('SummaryReportsInformationInput AdminSumCash').blur()})}
                                                    onBlur={((e) => {
                                                        setLoadingAdminSumCash(false)      
                                                        const Value = e.target.value     
                                                        const monthValue = parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1
                                                        const yearValue = parseFloat(new Date(SelectedPeriod.Max).getFullYear())  
                                                        if(parseFloat(AdvanceReportED.filter((i) => 
                                                            i.idCity === parseInt(el.id) &&
                                                            i.MonthValue === monthValue &&
                                                            i.YearValue === yearValue
                                                        )[0].AdminSumCash) !== parseFloat(Value)) {
                                                            axios.get(Server + 'cityadvancereports?_limit=-1', {
                                                                headers: {
                                                                    Authorization: 'Bearer ' + User.jwt,
                                                                    },
                                                                params: {
                                                                    idCity: parseInt(el.id),
                                                                    MonthValue: monthValue,
                                                                    YearValue: yearValue
                                                                }
                                                            }).then((response) => {
                                                                axios.put(Server + 'cityadvancereports/' + response.data[0].id, {
                                                                    AdminSumCash: parseFloat(Value),
                                                                }, {
                                                                    headers: {
                                                                    Authorization: 'Bearer ' + User.jwt,
                                                                    },
                                                                })
                                                                .then(() => {
                                                                    setLoadingAdminSumCash(true)    
                                                                    dispatch(changeInfAdvanceReport({
                                                                        id: parseInt(AdvanceReportED.filter((i) => 
                                                                            i.idCity === parseInt(el.id) &&
                                                                            i.MonthValue === monthValue &&
                                                                            i.YearValue === yearValue
                                                                        )[0].id), 
                                                                        Type: 'AdminSumCash',
                                                                        Value: parseFloat(Value)
                                                                    }))                                                                    
                                                                })
                                                                .catch(() => {
                                                                    document.getElementById('SummaryReportsInformationInput AdminSumCash').value = document.getElementById('SummaryReportsInformationInput AdminSumCash').defaultValue
                                                                    alert('Ошибка сохранения данных, повторите ввод.')
                                                                    setLoadingAdminSumCash(true)   
                                                                })
                                                            })
                                                        } else {
                                                            setLoadingAdminSumCash(true)
                                                        }
                                                    })}
                                                    />
                                                    {!isLoadingAdminSumCash && <div className="MiniSpinSummaryResultDiv"> <div className="MiniSpinSummaryResult" /> </div>}
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Безнал </div>
                                                    <input
                                                    type="number"
                                                    className="SummaryReportsInformationInput"
                                                    id='SummaryReportsInformationInput AdminSumNonCash'
                                                    defaultValue={AdvanceReportED.filter((item) => 
                                                        item.idCity === el.id 
                                                        &&
                                                        parseFloat(item.MonthValue) === parseFloat(new Date(SelectedPeriod.Min).getMonth() + 1)
                                                        &&
                                                        parseFloat(item.YearValue) === parseFloat(new Date(SelectedPeriod.Min).getFullYear())
                                                        )[0].AdminSumNonCash}
                                                    onFocus={(() => {
                                                        if(User.user.role.id === roleId.director)
                                                            document.getElementById('SummaryReportsInformationInput AdminSumNonCash').blur()
                                                    })}
                                                    onBlur={((e) => {
                                                        setLoadingAdminSumNonCash(false)      
                                                        const Value = e.target.value     
                                                        const monthValue = parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1
                                                        const yearValue = parseFloat(new Date(SelectedPeriod.Max).getFullYear()) 
                                                        if(parseFloat(AdvanceReportED.filter((i) => 
                                                            i.idCity === parseInt(el.id) &&
                                                            i.MonthValue === monthValue &&
                                                            i.YearValue === yearValue
                                                        )[0].AdminSumNonCash) !== parseFloat(Value))
                                                        {
                                                            axios.get(Server + 'cityadvancereports?_limit=-1', {
                                                                headers: {
                                                                    Authorization: 'Bearer ' + User.jwt,
                                                                    },
                                                                params: {
                                                                    idCity: parseInt(el.id),
                                                                    MonthValue: monthValue,
                                                                    YearValue: yearValue
                                                                }
                                                            }).then((response) => {
                                                                axios.put(Server + 'cityadvancereports/' + response.data[0].id, {
                                                                    AdminSumNonCash: Value,
                                                                }, {
                                                                    headers: {
                                                                    Authorization: 'Bearer ' + User.jwt,
                                                                    },
                                                                })
                                                                .then(() => {
                                                                    setLoadingAdminSumNonCash(true)     
                                                                    dispatch(changeInfAdvanceReport({
                                                                        id: parseInt(AdvanceReportED.filter((i) => 
                                                                            i.idCity === parseInt(el.id) &&
                                                                            i.MonthValue === monthValue &&
                                                                            i.YearValue === yearValue
                                                                        )[0].id), 
                                                                        Type: 'AdminSumNonCash',
                                                                        Value: parseFloat(Value)
                                                                    }))                                                                      
                                                                })
                                                                .catch(() => {
                                                                    document.getElementById('SummaryReportsInformationInput AdminSumNonCash').value = document.getElementById('SummaryReportsInformationInput AdminSumNonCash').defaultValue
                                                                    alert('Ошибка сохранения данных, повторите ввод.')
                                                                    setLoadingAdminSumNonCash(true)   
                                                                })
                                                            })           
                                                        }   
                                                        else
                                                        {
                                                            setLoadingAdminSumNonCash(true) 
                                                        }
                                                    })}
                                                    />
                                                    {!isLoadingAdminSumNonCash && <div className="MiniSpinSummaryResultDiv"> <div className="MiniSpinSummaryResult"/> </div>}
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Итого </div>
                                                    <div>
                                                        {(parseFloat(AdvanceReportED.filter((item) => 
                                                        item.idCity === el.id 
                                                        &&
                                                        parseFloat(item.MonthValue) === parseFloat(new Date(SelectedPeriod.Min).getMonth() + 1)
                                                        &&
                                                        parseFloat(item.YearValue) === parseFloat(new Date(SelectedPeriod.Min).getFullYear())
                                                        )[0].AdminSumNonCash) 
                                                        + 
                                                        parseFloat(AdvanceReportED.filter((item) => 
                                                        item.idCity === el.id 
                                                        &&
                                                        parseFloat(item.MonthValue) === parseFloat(new Date(SelectedPeriod.Min).getMonth() + 1)
                                                        &&
                                                        parseFloat(item.YearValue) === parseFloat(new Date(SelectedPeriod.Min).getFullYear())
                                                        )[0].AdminSumCash)).toFixed(2)}
                                                    </div>

                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Остаток </div>                                                    
                                                    <div>
                                                        {((parseFloat(AdvanceReportED.filter((item) => 
                                                        item.idCity === el.id 
                                                        &&
                                                        parseFloat(item.MonthValue) === parseFloat(new Date(SelectedPeriod.Min).getMonth() + 1)
                                                        &&
                                                        parseFloat(item.YearValue) === parseFloat(new Date(SelectedPeriod.Min).getFullYear())
                                                        )[0].AdminSumNonCash) 
                                                        + 
                                                        parseFloat(AdvanceReportED.filter((item) => 
                                                        item.idCity === el.id 
                                                        &&
                                                        parseFloat(item.MonthValue) === parseFloat(new Date(SelectedPeriod.Min).getMonth() + 1)
                                                        &&
                                                        parseFloat(item.YearValue) === parseFloat(new Date(SelectedPeriod.Min).getFullYear())
                                                        )[0].AdminSumCash)) * (parseFloat(AdvanceReportED.filter((item) => 
                                                            item.idCity === el.id 
                                                            &&
                                                            parseFloat(item.MonthValue) === parseFloat(new Date(SelectedPeriod.Min).getMonth() + 1)
                                                            &&
                                                            parseFloat(item.YearValue) === parseFloat(new Date(SelectedPeriod.Min).getFullYear())
                                                            )[0].PercentRemains) / 100)).toFixed(2)}
                                                    </div>                                                    
                                                </div>

                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText">
                                                        % остатка
                                                    </div>
                                                    <input
                                                    type="number"
                                                    className="SummaryReportsInformationInput"
                                                    id='SummaryReportsInformationInput PercentRemains'
                                                    defaultValue={AdvanceReportED.filter((item) => 
                                                        item.idCity === el.id 
                                                        &&
                                                        parseFloat(item.MonthValue) === parseFloat(new Date(SelectedPeriod.Min).getMonth() + 1)
                                                        &&
                                                        parseFloat(item.YearValue) === parseFloat(new Date(SelectedPeriod.Min).getFullYear())
                                                        )[0].PercentRemains}
                                                    onFocus={(() => {if(User.user.role.id === roleId.director) document.getElementById('SummaryReportsInformationInput PercentRemains').blur()})}
                                                    onBlur={((e) => {
                                                        setLoadingPercentRemains(false)      
                                                        const Value = e.target.value     
                                                        const monthValue = parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1
                                                        const yearValue = parseFloat(new Date(SelectedPeriod.Max).getFullYear())  
                                                        if(parseFloat(AdvanceReportED.filter((i) => 
                                                            i.idCity === parseInt(el.id) &&
                                                            i.MonthValue === monthValue &&
                                                            i.YearValue === yearValue
                                                        )[0].PercentRemains) !== parseFloat(Value))
                                                        {
                                                            axios.get(Server + 'cityadvancereports?_limit=-1', {
                                                                headers: {
                                                                    Authorization: 'Bearer ' + User.jwt,
                                                                    },
                                                                params: {
                                                                    idCity: parseInt(el.id),
                                                                    MonthValue: monthValue,
                                                                    YearValue: yearValue
                                                                }
                                                            }).then((response) => {
                                                                axios.put(Server + 'cityadvancereports/' + response.data[0].id, {
                                                                    PercentRemains: Value,
                                                                }, {
                                                                    headers: {
                                                                    Authorization: 'Bearer ' + User.jwt,
                                                                    },
                                                                })
                                                                .then(() => {
                                                                    setLoadingPercentRemains(true)   
                                                                    dispatch(changeInfAdvanceReport({
                                                                        id: parseInt(AdvanceReportED.filter((i) => 
                                                                            i.idCity === parseInt(el.id) &&
                                                                            i.MonthValue === monthValue &&
                                                                            i.YearValue === yearValue
                                                                        )[0].id), 
                                                                        Type: 'PercentRemains',
                                                                        Value: parseFloat(Value)
                                                                    }))                                                                        
                                                                })
                                                                .catch(() => {
                                                                    document.getElementById('SummaryReportsInformationInput PercentRemains').value = document.getElementById('SummaryReportsInformationInput PercentRemains').defaultValue
                                                                    alert('Ошибка сохранения данных, повторите ввод.')
                                                                    setLoadingPercentRemains(true)   
                                                                })
                                                            })              
                                                        }
                                                        else
                                                        {
                                                            setLoadingPercentRemains(true)  
                                                        }
                                                    })}
                                                    />
                                                    {!isLoadingPercentRemains && <div className="MiniSpinSummaryResultDiv"> <div className="MiniSpinSummaryResult"/> </div>}
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv Textarea">
                                                    <div className="SummaryReportsInformationText"> Комментарий </div>
                                                    <textarea
                                                    type="number"
                                                    className="SummaryReportsInformationTextarea"
                                                    id="SummaryReportsInformationInput AdminComment"
                                                    maxLength={200}
                                                    defaultValue={AdvanceReportED.filter((item) => 
                                                        item.idCity === el.id 
                                                        &&
                                                        parseFloat(item.MonthValue) === parseFloat(new Date(SelectedPeriod.Min).getMonth() + 1)
                                                        &&
                                                        parseFloat(item.YearValue) === parseFloat(new Date(SelectedPeriod.Min).getFullYear())
                                                        )[0].AdminComment}
                                                    onFocus={(() => {if(User.user.role.id === roleId.director) document.getElementById('SummaryReportsInformationInput AdminComment').blur()})}
                                                    onBlur={((e) => {
                                                        setLoadingAdminComment(false)      
                                                        const Value = e.target.value     
                                                        const monthValue = parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1
                                                        const yearValue = parseFloat(new Date(SelectedPeriod.Max).getFullYear())
                                                        if((AdvanceReportED.filter((i) => 
                                                            i.idCity === parseInt(el.id) &&
                                                            i.MonthValue === monthValue &&
                                                            i.YearValue === yearValue
                                                        )[0].AdminComment) !== Value)
                                                        {  
                                                            axios.get(Server + 'cityadvancereports?_limit=-1', {
                                                                headers: {
                                                                    Authorization: 'Bearer ' + User.jwt,
                                                                    },
                                                                params: {
                                                                    idCity: parseInt(el.id),
                                                                    MonthValue: monthValue,
                                                                    YearValue: yearValue
                                                                }
                                                            }).then((response) => {
                                                                axios.put(Server + 'cityadvancereports/' + response.data[0].id, {
                                                                    AdminComment: Value,
                                                                }, {
                                                                    headers: {
                                                                    Authorization: 'Bearer ' + User.jwt,
                                                                    },
                                                                })
                                                                .then(() => {
                                                                    setLoadingAdminComment(true)     
                                                                    dispatch(changeInfAdvanceReport({
                                                                        id: parseInt(AdvanceReportED.filter((i) => 
                                                                            i.idCity === parseInt(el.id) &&
                                                                            i.MonthValue === monthValue &&
                                                                            i.YearValue === yearValue
                                                                        )[0].id), 
                                                                        Type: 'AdminComment',
                                                                        Value: String(Value)
                                                                    }))                                                                     
                                                                })
                                                                .catch(() => {
                                                                    document.getElementById('SummaryReportsInformationInput AdminComment').value = document.getElementById('SummaryReportsInformationInput AdminComment').defaultValue
                                                                    alert('Ошибка сохранения данных, повторите ввод.')
                                                                    setLoadingAdminComment(true)   
                                                                })
                                                            })     
                                                        }
                                                        else
                                                        {
                                                            setLoadingAdminComment(true)   
                                                        }         
                                                    })}
                                                    />
                                                    {!isLoadingAdminComment && <div className="MiniSpinSummaryResultDiv Comment"> <div className="MiniSpinSummaryResult"/> </div>}
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Выручка ФП </div>
                                                    <input
                                                    type="number"
                                                    className="SummaryReportsInformationInput"
                                                    id="SummaryReportsInformationInput RevenueFrontpad"
                                                    defaultValue={getRevenueFrontpad(el.id)}
                                                    onFocus={(() => { if(User.user.role.id === roleId.director) document.getElementById('SummaryReportsInformationInput RevenueFrontpad').blur()})}
                                                    onBlur={((e) => {
                                                        setLoadingRevenueFrontpad(false)      
                                                        const Value = e.target.value     
                                                        const monthValue = parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1
                                                        const yearValue = parseFloat(new Date(SelectedPeriod.Max).getFullYear())
                                                        if(parseFloat(AdvanceReportED.filter((i) => 
                                                            i.idCity === parseInt(el.id) &&
                                                            i.MonthValue === monthValue &&
                                                            i.YearValue === yearValue
                                                        )[0].RevenueFrontpad) !== parseFloat(Value))
                                                        {     
                                                            axios.get(Server + 'cityadvancereports?_limit=-1', {headers: { Authorization: 'Bearer ' + User.jwt,},
                                                                params: {
                                                                    idCity: parseInt(el.id),
                                                                    MonthValue: monthValue,
                                                                    YearValue: yearValue
                                                                }
                                                            }).then((response) => {
                                                                axios.put(Server + 'cityadvancereports/' + response.data[0].id, { RevenueFrontpad: parseFloat(Value), }, {
                                                                    headers: { Authorization: 'Bearer ' + User.jwt },
                                                                })
                                                                .then(() => {
                                                                    setLoadingRevenueFrontpad(true)       
                                                                    dispatch(changeInfAdvanceReport({
                                                                        id: parseInt(AdvanceReportED.filter((i) => 
                                                                            i.idCity === parseInt(el.id) &&
                                                                            i.MonthValue === monthValue &&
                                                                            i.YearValue === yearValue
                                                                        )[0].id), 
                                                                        Type: 'RevenueFrontpad',
                                                                        Value: parseFloat(Value)
                                                                    }))                                                                     
                                                                })
                                                                .catch(() => {
                                                                    document.getElementById('SummaryReportsInformationInput RevenueFrontpad').value = document.getElementById('SummaryReportsInformationInput RevenueFrontpad').defaultValue
                                                                    alert('Ошибка сохранения данных, повторите ввод.')
                                                                    setLoadingRevenueFrontpad(true)   
                                                                })
                                                            })             
                                                        } 
                                                        else
                                                        {
                                                            setLoadingRevenueFrontpad(true)  
                                                        }
                                                    })}
                                                    />
                                                    {!isLoadingRevenueFrontpad && <div className="MiniSpinSummaryResultDiv"> <div className="MiniSpinSummaryResult"/> </div>                                                         
                                                    }
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Выручка </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getRevenue(el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Выручка % </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getRevenuePercent(el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Закупка </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getByName('Закупка', el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Закупка % </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getPercentByName('Закупка', el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Заработная плата </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getByName('Заработная плата', el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Заработная плата % </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getPercentByName('Заработная плата', el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Прочие расходы </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getOtherExpenses(el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Прочие расходы % </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getOtherExpensesPercent(el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Оплата доставки </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getByName('Оплата доставки', el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Оплата доставки % </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getPercentByName('Оплата доставки', el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Кол-во доставок </div>
                                                    <input
                                                    type="number"
                                                    className="SummaryReportsInformationInput"
                                                    id="SummaryReportsInformationInput NumDelivery"
                                                    defaultValue={getNumDelivery(el.id)}
                                                    onFocus={(() => { if(User.user.role.id === roleId.director) document.getElementById('SummaryReportsInformationInput NumDelivery').blur() })}
                                                    onBlur={((e) => {
                                                        setLoadingNumDelivery(false)      
                                                        const Value = e.target.value     
                                                        const monthValue = parseFloat(new Date(SelectedPeriod.Max).getMonth()) + 1
                                                        const yearValue = parseFloat(new Date(SelectedPeriod.Max).getFullYear())
                                                        if(parseFloat(AdvanceReportED.filter((i) => 
                                                            i.idCity === parseInt(el.id) &&
                                                            i.MonthValue === monthValue &&
                                                            i.YearValue === yearValue
                                                        )[0].NumDelivery) !== parseFloat(Value))
                                                        {     
                                                            axios.get(Server + 'cityadvancereports?_limit=-1', {
                                                                headers: {
                                                                    Authorization: 'Bearer ' + User.jwt,
                                                                    },
                                                                params: {
                                                                    idCity: parseInt(el.id),
                                                                    MonthValue: monthValue,
                                                                    YearValue: yearValue
                                                                }
                                                            }).then((response) => {
                                                                axios.put(Server + 'cityadvancereports/' + response.data[0].id, {
                                                                    NumDelivery: parseFloat(Value),
                                                                }, {
                                                                    headers: {
                                                                    Authorization: 'Bearer ' + User.jwt,
                                                                    },
                                                                })
                                                                .then(() => {
                                                                    setLoadingNumDelivery(true) 
                                                                    dispatch(changeInfAdvanceReport({
                                                                        id: parseInt(AdvanceReportED.filter((i) => 
                                                                            i.idCity === parseInt(el.id) &&
                                                                            i.MonthValue === monthValue &&
                                                                            i.YearValue === yearValue
                                                                        )[0].id), 
                                                                        Type: 'NumDelivery',
                                                                        Value: parseFloat(Value)
                                                                    }))                                                                           
                                                                })
                                                                .catch(() => {
                                                                    document.getElementById('SummaryReportsInformationInput NumDelivery').value = document.getElementById('SummaryReportsInformationInput NumDelivery').defaultValue
                                                                    alert('Ошибка сохранения данных, повторите ввод.')
                                                                    setLoadingNumDelivery(true)   
                                                                })
                                                            })            
                                                        }
                                                        else
                                                        {
                                                            setLoadingNumDelivery(true)
                                                        }  
                                                    })}
                                                    />
                                                    {!isLoadingNumDelivery && <div className="MiniSpinSummaryResultDiv"> <div className="MiniSpinSummaryResult"/> </div>}
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Стоимость 1 доставки </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getCostPerDelivery(el.id)}
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="SummaryReportsBackgroundInformation">
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Выручка ФП </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getRevenueFrontpad(el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Выручка </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getRevenue(el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText">
                                                        Выручка %
                                                    </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getRevenuePercent(el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Закупка </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getByName('Закупка', el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Закупка %</div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getPercentByName('Закупка', el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Заработная плата </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getByName('Заработная плата', el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Заработная плата % </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getPercentByName('Заработная плата', el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Прочие расходы </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getOtherExpenses(el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv" >
                                                    <div className="SummaryReportsInformationText"> Прочие расходы % </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getOtherExpensesPercent(el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Оплата доставки </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getByName('Оплата доставки', el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Оплата доставки % </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getPercentByName('Оплата доставки', el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Кол-во доставок </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getNumDelivery(el.id)}
                                                    </div>
                                                </div>
                                                <div className="SummaryReportsOneInformationDiv">
                                                    <div className="SummaryReportsInformationText"> Стоимость 1 доставки </div>
                                                    <div className="SummaryReportsInformationText">
                                                        {getCostPerDelivery(el.id)}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            }
                        </div>
                        }
                    </>
                    )}                    
                </div>

            </div>

            {OpenModalArticles && 
            <div className="AddArticleEDGlobalDiv">
                <div className="SummaryReportsModalArticlesMainDiv">
                    <div className="CloseAddArticleEDButtonDiv">
                        <button className="CloseModalIconDiv"
                        onClick={(() => {
                            SelectArticle({id: 0, idCity: 0, TransactionType: 'All'})
                            setOpenModalArticles(false)
                        })}
                        >
                            <IoClose className="CloseModalIcon"/>
                        </button>
                    </div>
                    <div className="SummaryReportsModalArticlesDiv">
                        {AdvanceReportED.length > 0 && 
                            (AdvanceReportED.map((item) => 
                                item.idCity === SelectedArticle.idCity && 
                                item.AdminArticles.map((a) => 
                                a.CreateAd <= (SelectedPeriod.Max + 'T23:59')
                                &&
                                a.CreateAd >= (SelectedPeriod.Min + 'T00:00')
                                &&
                                a.idArticle=== SelectedArticle.id
                                &&
                                (SelectedArticle.TransactionType === 'All' || a.TransactionType === SelectedArticle.TransactionType)
                                &&
                                <div key={a.id} className={"SummaryReportsOneArticleMain " + a.Type}>
                                    <div className="SummaryReportsModalOneArticleDiv Fat">
                                        {a.CreateAd.split('T')[0].split('-')[2] + '.' + a.CreateAd.split('T')[0].split('-')[1] + '.' + a.CreateAd.split('T')[0].split('-')[0]}
                                    </div>
                                    <div className="SummaryReportsModalOneArticleDiv Fat">
                                        {a.Name }
                                        <button className="FilterButtonAR Edit" 
                                        onClick={(() => {
                                            let elCreateAdDate = a.CreateAd.split('T')[0]
                                            let elCreateAdTime = a.CreateAd.split('T')[1]
                                            dispatch(openEditAddedArticle({
                                                id: a.id,
                                                idArticle: a.idArticle,
                                                Sum: a.Sum,
                                                Name: a.Name,
                                                ResponsibleUserName: a.ResponsibleUserName,
                                                OtherExpenditure: a.OtherExpenditure,
                                                TransactionType: a.TransactionType,
                                                Type: a.Type,
                                                Comment: arguments.Comment,
                                                CreateAdDate: elCreateAdDate,
                                                CreateAdTime: elCreateAdTime,
                                                AddAdminArticle: true,
                                                AddAdminOtherExpenditure: false,
                                                idCity: SelectedArticle.idCity
                                            }))
                                            dispatch(setOpenAddArticleED(true))
                                        })}                                    
                                        > 
                                            <FaPencil />
                                        </button>
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv ResponsibleUserName">
                                    {'Внесено только в сводный отчет'}
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv">
                                        {a.TransactionType === 'Cash' ? 'Тип операции: Нал' : 'Тип операции: Безнал'}
                                    </div>
                                    
                                    <div className="SummaryReportsModalOneArticleDiv">
                                        {'Сумма: ' + a.Sum + ' руб.'}
                                    </div>                                    

                                    <div className="SummaryReportsModalOneArticleDiv ResponsibleUserName">
                                        {'Автор: ' + a.ResponsibleUserName}
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv">
                                        {'Комментарий: ' + a.Comment}
                                    </div>
                                </div>
                                )                                
                        ))} 
                        {AdvanceReportED.length > 0 && 
                            (AdvanceReportED.map((item) => 
                                item.idCity === SelectedArticle.idCity && 
                                item.Articles.map((a) => 
                                a.CreateAd <= (SelectedPeriod.Max + 'T23:59')
                                &&
                                a.CreateAd >= (SelectedPeriod.Min + 'T00:00')
                                &&
                                a.idArticle=== SelectedArticle.id
                                &&
                                (SelectedArticle.TransactionType === 'All' || a.TransactionType === SelectedArticle.TransactionType)
                                &&
                                <div
                                key={a.id}
                                className={"SummaryReportsOneArticleMain " + a.Type}
                                >
                                    <div className="SummaryReportsModalOneArticleDiv Fat">
                                        {a.CreateAd.split('T')[0].split('-')[2] + '.' + a.CreateAd.split('T')[0].split('-')[1] + '.' + a.CreateAd.split('T')[0].split('-')[0]}
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv Fat">
                                        {a.Name}
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv">
                                        {a.TransactionType === 'Cash' ? 'Тип операции: Нал' : 'Тип операции: Безнал'}
                                    </div>
                                    
                                    <div className="SummaryReportsModalOneArticleDiv">
                                        {'Сумма: ' + a.Sum + ' руб.'}
                                    </div>                                    

                                    <div className="SummaryReportsModalOneArticleDiv ResponsibleUserName">
                                        {'Автор: ' + a.ResponsibleUserName}
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv">
                                        {'Комментарий: ' + a.Comment}
                                    </div>
                                </div>
                                )                                
                        ))} 
                    </div>
                </div>
            </div>
            }

            {OpenModalArticlesOtherExpenditure && 
            <div className="AddArticleEDGlobalDiv">
                <div className="SummaryReportsModalArticlesMainDiv">
                    <div className="CloseAddArticleEDButtonDiv">
                        <button className="CloseModalIconDiv"
                        onClick={(() => {
                            SelectArticleOtherExpenditure ({idCity: 0, TransactionType: 'All'})
                            setOpenModalArticlesOtherExpenditure (false)
                        })}
                        >
                            <IoClose className="CloseModalIcon" />
                        </button>
                    </div>
                    <div className="SummaryReportsModalArticlesDiv">
                        {AdvanceReportED.length > 0 && 
                            (AdvanceReportED.map((item) => 
                                item.idCity === SelectedArticleOtherExpenditure.idCity && 
                                item.AdminArticles.map((a) => 
                                a.CreateAd <= (SelectedPeriod.Max + 'T23:59')
                                &&
                                a.CreateAd >= (SelectedPeriod.Min + 'T00:00')
                                &&
                                a.Type === 'expenditure'
                                &&
                                (Article.Expenditure.find((el) => el.id === a.idArticle) && Article.Expenditure.find((el) => el.id === a.idArticle).OtherExpenditure)
                                &&
                                (SelectedArticleOtherExpenditure.TransactionType === 'All' || a.TransactionType === SelectedArticleOtherExpenditure.TransactionType)
                                &&
                                <div key={a.id} className={"SummaryReportsOneArticleMain " + a.Type}>
                                    <div className="SummaryReportsModalOneArticleDiv Fat">
                                        {a.CreateAd.split('T')[0].split('-')[2] + '.' + a.CreateAd.split('T')[0].split('-')[1] + '.' + a.CreateAd.split('T')[0].split('-')[0]}
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv Fat">
                                        {a.Name }
                                        <button className="FilterButtonAR Edit"  
                                        onClick={(() => {
                                            let elCreateAdDate = a.CreateAd.split('T')[0]
                                            let elCreateAdTime = a.CreateAd.split('T')[1]
                                            dispatch(openEditAddedArticle({
                                                id: a.id,
                                                idArticle: a.idArticle,
                                                Sum: a.Sum,
                                                Name: a.Name,
                                                ResponsibleUserName: a.ResponsibleUserName,
                                                OtherExpenditure: a.OtherExpenditure,
                                                TransactionType: a.TransactionType,
                                                Type: a.Type,
                                                Comment: arguments.Comment,
                                                CreateAdDate: elCreateAdDate,
                                                CreateAdTime: elCreateAdTime,
                                                AddAdminArticle: false,
                                                AddAdminOtherExpenditure: true,
                                                idCity: SelectedArticleOtherExpenditure.idCity
                                            }))
                                            dispatch(setOpenAddArticleED(true))
                                        })}                                          
                                        > 
                                            <FaPencil />
                                        </button>
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv ResponsibleUserName">
                                        {' Внесено только в сводный отчет'}
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv">
                                        {a.TransactionType === 'Cash' ? 'Тип операции: Нал' : 'Тип операции: Безнал'}
                                    </div>
                                    
                                    <div className="SummaryReportsModalOneArticleDiv">
                                        {'Сумма: ' + a.Sum + ' руб.'}
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv ResponsibleUserName">
                                        {'Автор: ' + a.ResponsibleUserName}
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv">
                                        {'Комментарий: ' + a.Comment}
                                    </div>
                                </div>
                                )                                
                        ))} 
                        {AdvanceReportED.length > 0 && 
                            (AdvanceReportED.map((item) => 
                                item.idCity === SelectedArticleOtherExpenditure.idCity && 
                                item.Articles.map((a) => 
                                a.CreateAd <= (SelectedPeriod.Max + 'T23:59')
                                &&
                                a.CreateAd >= (SelectedPeriod.Min + 'T00:00')
                                &&
                                a.Type === 'expenditure'
                                &&
                                (Article.Expenditure.find((el) => el.id === a.idArticle) && Article.Expenditure.find((el) => el.id === a.idArticle).OtherExpenditure)
                                &&
                                (SelectedArticleOtherExpenditure.TransactionType === 'All' || a.TransactionType === SelectedArticleOtherExpenditure.TransactionType)
                                &&
                                <div key={a.id} className={"SummaryReportsOneArticleMain " + a.Type}>
                                    <div className="SummaryReportsModalOneArticleDiv Fat">
                                        {a.CreateAd.split('T')[0].split('-')[2] + '.' + a.CreateAd.split('T')[0].split('-')[1] + '.' + a.CreateAd.split('T')[0].split('-')[0]}
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv Fat">
                                        {a.Name}
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv">
                                        {a.TransactionType === 'Cash' ? 'Тип операции: Нал' : 'Тип операции: Безнал'}
                                    </div>
                                    
                                    <div className="SummaryReportsModalOneArticleDiv">
                                        {'Сумма: ' + a.Sum + ' руб.'}
                                    </div>                                    

                                    <div className="SummaryReportsModalOneArticleDiv ResponsibleUserName">
                                        {'Автор: ' + a.ResponsibleUserName}
                                    </div>

                                    <div className="SummaryReportsModalOneArticleDiv">
                                        {'Комментарий: ' + a.Comment}
                                    </div>
                                </div>
                            )
                        ))} 
                    </div>
                </div>
            </div>
            }
        </div>
    )
}

export default SummaryReports